webpackJsonp([49],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAYCAYAAACMcW/9AAAABGdBTUEAALGPC/xhBQAAA11JREFUSA29V01oE0EUfjNJWqilRSmWBkIhJtkoKL14ETxIU/HgQQ+CCEUP1osIelIRe6iKCoKCeJEeFEEEBT14kLbioeDFS1Gw+TNQAimForTUQNvsjt9Lu7BuN5NNGt3LzLz3ve99O2/ebCIITyZT6rFo5Y4gNUQkdpKiGQrKsWQs9on9/+tJ5/NHqGKNkqABIvVLkZiU1HnDMMKLIp/P716vmDMQ0+cWJKS4lUwkRt32f7FOZ7NjylI3PbjnQ8HAgKyY5gM4t4jkAA4EwUOP4JaaOEcNkZynjzVKlHlQlxUEl2czuadKKanDNeNjzio3cmjjodFfcmWNZDK5FyAOagkbcDIXc6JsI37CJA7uRz9ARepMJpt9gwRtfvA6DHNUucCpw9k+JeTURjOZ1ldSqtd26Ecx0d3VeTIcDpf1OG9vqVTqWFpeeYsOOOqNcFmFWAgF5AHB5lwut69iWlOYejaVK5SEENMBKY7H4/Flt0+3Rp4u01LvsaOHdTiHbz4YkCnk+V49ozyBgYPnHKCaU05kWtZUsVjcVRPkcjCWYxoQOceaWBtTVXfU5sSdGsGdyjubsG26EcHf2tpCQ9FodEGHKxQKvWtr65OKaL8O5/BlcXemYrFY0bb9JZSNrSC1yXls1ctvEcrkXKbf5fIHpeggr308XKZBlOmHE4szuQdnn2+Vfqe91lwI+rKjo+NYJBL56cZ43qMMDEiZ4qZxB9RY90PQNDel7ec527D2KZIbVKa8RDKn547ayRq9SrAji0hWvXbQOBOoSI/NpR/rX3laoUyOnWlH0ldIekKfbMOLKizxDN3d7Q9P7/Byp3FsVnX4ukI3k/Ln7jl/nXRkjfoEiZeGET+Ll6vUi/U8o+4gJgLhMEo77vY1u2auDc76IjmHL6EMhFjLSCQu4DfqI15v52GOpGGMMKdfHt9CmRDECj+kr6Bkt/0mcOM4ljnc9nprX2fUiySdzl1VZN3z8tWyCZLXksn4/Vp+nb1poUyKBruIBnuMDtfycCWwk5dwJp/oxOh82gS6QNs3m82eE4rGITZg25wjRJpQeX5vIvHMaW90vm2hnBDH4BQJxf8A2p0CIHKVlBhGuV877c3MWyKUE6cLBUOtV+5iemhTyGcRCl5PRqOZzfW2hj/rYmnha377FwAAAABJRU5ErkJggg=="

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAYCAYAAACMcW/9AAAABGdBTUEAALGPC/xhBQAAAcZJREFUSA29lrFOAkEURdUYSSwsDMGKioKEzk/wI+jp+QB6+ABqtZLEVm2tTCwt7WyMDcbEQksLI567ziRLnGXfMrO85DqzM+/dd1x2Yba2iMVi0USn6Bl9oDt0or1Nhnq63mIQi5iaGQOTFnpFoRhvCpTm4xAAa2Jr6W7OChL88rRuWBpNfbOCcSbQecFmfvmMi53UwPJE8i6LuRVURpdoNxWsvJwnQ2lkoGUffd7lhou9WFh5IHlZ40J3VC/Tm7WCvFu0vy6sap0HgynE1sr6Memhojc/5HbP4kFVWNUg1VpDTL2lPix00IvVgbwHdLhksuJCua6GwRRi6QQt2WijJ5PNX9Ijw1HQLLeoHKRca4ihnbP4PyUhqakaouT/fEaOcZKPCZ9aHycPG/XgA7mRF9TDVv0qeQfw2Elza0R95XnYBt2urR3J+3Sylsi7kTWL/YNRlZ87K6Dykv4s+zurA8R5FYqS3FoOOh52m+ZlR7ISvmy79qOjB55YaApyJrGPYqV6IEYFIKuWR5WapEqGaIh+VpG5PeUMU/VdyweAAfp2QKFBe4O1zFMXAdJHXwFKrfVT94vyA6iLrpAOupLm3SjTXPEvKql9jHC3KXIAAAAASUVORK5CYII="

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Message__ = __webpack_require__(38);


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.prototype.$message = __WEBPACK_IMPORTED_MODULE_0__Message__["a" /* default */];
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ch_js__ = __webpack_require__(39);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = {
  en: {
    language: {
      // 404页面
      notFoundMsg: "Page not found",
      // header & footer
      headerServices: "Services",
      headerServicesOur: "Products",
      headerServicesDelivery: "Cloud APP Delivery",
      headerServicesConnection: "Cloud Xpress Connect",
      headerServicesSd: "SD-WAN",
      headerServicesGlobal: "Global APP Access",
      headerSolutions: "Solutions",
      headerSolutionsOur: "Our Solutions",
      headerSolutionsSaas: "SaaS Acceleration",
      headerSolutionsCloud: " Private Cloud Service",
      headerSolutionsMpls: "MPLS Hybrid",
      headerSolutionGlobal: "Company OA/ERR platform acceleration ",
      headerAbout: "About US",
      aboutCompany: "About Company",
      aboutTeam: "Our Team",
      aboutInver: "Investor",
      headerLanguage: "中文",
      headerLog: "Login",
      footerHome: "Home",
      footerService: "service",
      footerTech: "Technical Support",
      footerAbout: "About us",
      footerBack: "Back to top",

      // 主页文字
      mainWhatWan: "What is SD-WAN",
      mainWhatWanDefined: "Software-Defined Network",
      mainWhatWanGlobal: "Global Deployment",
      mainWhatWanConnection: "Enterprise Network Connection",
      mainWhyWan: "Why choose OBC SD-WAN",
      mainWhyWanHeight: "High Performance Data Transmission",
      mainWhyWanStrong: "Strong Security",
      mainWhyWanFlexible: "Flexible Deployment",
      mainCloud: "Cloud APP Delivery",
      mainCloudSaas: "Global SaaS Acceleration",
      mainCloudApp: "Protecting Application Data",
      mainCloudSoho: "Flexible Deployment",
      mainCloudRemote: "Real-time and Comprehensive Monitor",
      mainCloudConnection: "Cloud Xpress Connect",
      mainCloud1: "Cloud Xpress Connect",
      mainGlobal: "Enterprise Global Special Network",
      mainData: "Enterprise Data Acceleration",
      mainSimple: "Simple Deployment",
      mainSafeData: "Secured Data Channel",
      mainCloudBranch: "Enterprise Global Special Network",
      mainCloudData: "Enterprise Data Acceleration",
      mainCloudSecured: "Secured Data Channel",
      mainCloudEasy: "Simple Deployment",
      mainFeatures: "Our Features",
      mainFeaturesWe: "We are a pioneer of SD-WAN service solution provider",
      mainFeaturesBuild: "We build advanced, stable, high speed, low latency WAN networks to help enterprise users focus on their core business",
      mainPERFORMANCE: "High Performance",
      mainPERFORMANCEDetail: "With our FastIP technology, a high bandwidth network will be built between different locations",
      mainSECURITY: "Strong Security",
      mainRELIABILITYDetail: "High-intensity data encryption technology will ensure privacy during data transmission",
      mainRELIABILITY: "High Reliability",
      mainSECURITYDetail: "High availability guarantee with 7*24 service",
      mainSMART: "Smart Routing",
      mainSMARTDetail: "An auto-recovered network with decentralized artificial intelligence controller",
      mainEASY: "Easy to Use",
      mainEASYDetail: "A human friendly management websit for operator",
      mainREAL: "Real-time Monitoring",
      mainREALDetail: "Monitoring status each second, and raise alarm when problems found",
      mainANALYTICS: "Data Analysis",
      mainANALYTICSDetail: "Dash board with varieties of data, reports and statistics for analysis",
      mainFlexible: "Flexible Deployment",
      mainFlexibleDetail: "The OBC solutions can be deployed wherever there is Internet access.",
      mainGlobalEnterprise: "Global Enterprise Network with OBC Cloud Connection as a Service",
      mainGlobalWith: "It is efficient to set up a private Global Network Connectivity by OBC Cloud Xpress Connect Service.",
      mainGlobalImprove: "Improve Application Performance by OBC Cloud APP Delivery Service",
      mainGlobalSaas: "Enterprise cloud SaaS application (Office 365, Salesforce, SAP…) performance will accelerate at least 4 times with OBC Cloud Delivery Service.",
      mainWorldwide: "Globally Distributed SD-WAN Nodes",
      mainSmart: " Intelligent routing enables high availability",
      mainShowMore: "Expand to learn more",
      mainClickShowMore: "Click to learn more",

      // 服务
      serviceOur: "Our Products",
      serviceWe: "Learn more about the products we offer.",
      serviceCloud: "Cloud App Delivery",
      serviceSingle: "Flexible single-point deployment",
      serviceAcce: "Multiple SaaS application acceleration",
      serviceSingleEnd: "Specific country/regional site access acceleration",
      serviceUnderstand1: "Learn More",
      serviceConnectAs: "Cloud Xpress Connect",
      serviceDouble: "Point-to-point or multipoint-to-multipoint deployment",
      serviceBuild: "Build a global private network through OBC core network",
      serviceConnectCustomer: "Connect customer’s headquarters and offices across the globe",
      serviceOBC: "OBC SD-WAN Solutions",
      serviceHigh: "High performance",
      serviceStrong: "Strong security",
      serviceFlex: "Flexible deployment",
      serviceGlobalApp: "Global APP Access",
      serviceQuickly: "Quick distribution aimed content worldwide",
      serviceCustomer: "The Internet access will automatically select the closest OBC Cloud Node through our AI DNS transalation.",
      serviceSupports: "Support distributed deployment for both static resources and dynamic data",

      // 云快递
      deliveryCloud: "Cloud APP Delivery",
      deliveryAccApp: "Accelerate all Public Cloud applications such as Ali Mail, Office 365, Salesforce, etc.",
      deliveryAccVM: "Accelerate all Public Cloud VMs such as Ali Yun ECS, Amazon AWS, Microsoft Azure, etc.",
      deliveryAccService: "Accelerate Internet services for specific country or region.",
      deliveryProblem: "We privode the solutions of these problems",
      deliveryHighNet: "High latency when accessing the network in specific country/region",
      deliveryLowNet1: "Low network speed when accessing headquarter data Centre from branches",
      deliveryLowNet2: "Low network speed when accessing Public Cloud APP",
      deliveryAccNet: "Accelerate network speed in cross-region scenario",
      deliveryAccAll: "Accelerate all Public Cloud applications",

      // 云快线
      connectionService: "Cloud Xpress Connect",
      connectionInternet: "Internet",
      connectionOBC: "OBC Overlay Cloud connection",
      connectionProvide: "Provide OBC overlay cloud connection between edge connectors",
      connectionHeadquarter: "Cloud connection between headquarter and Private Cloud nodes",
      connectionBranches: "Cloud connection between branches and Public Cloud nodes",
      connectionHeadquarterBranches: "Cloud connection between headquarter and branches",
      connectionAchieve: "Achieve high-speed and low-latency transmission layer multinational connections",
      connectionPrivate: "WAN connection between headquarter and Private Cloud nodes",
      connectionPublic: "WAN connection between branches and Public Cloud nodes",
      connectionHead: "WAN connection between headquarter and branches",

      // SD
      SDWhat: "Why OBC SD-WAN",
      SDWith: "With the enterprise broadband access and Internet backbone network capacity increasing, SD-WAN provides a low-cost network solution based on existing circuits.",
      SDTradition: "Traditional MPLS Private Network",
      SDInTradition: "For traditional enterprise, applications like email, file-sharing, OA are centralize deployed. The traditional private or MPLS circuit has many limitations: complex deployment, expensive CAPEX/OPEX, and lack of flexibility.",
      SDLimitations: "Typically, branch offices that locates in different countries connect to headquarter's data center through the private or MPLS circuit, the architecture is shown below:",
      SDThen: "All these limitations can be overcome by SD-WAN solution",
      SDSDWan: "SD-WAN",
      SDEmploy: "SD-WAN employs the control/date plane segregation, centralized management and other SDN conceptions. It helps company to fast deploy WAN network across the world with an easy operation center.",
      SDDoyou: "Do you have or are you planning to deploy SD-WAN?",
      SDPER1: "We currently have an SD-WAN deployment",
      SDPER2: "We are considering SD-WANs",
      SDPER3: "We don't know SD-WAN",
      SDPER4: "We're deploying other WAN network",
      SDPER5: "We are actively planning for an SD-WAN",
      SDPER52: "deployment in the next 12 months",
      SDWhy: "Why OBC SD-WAN?",
      SDWeBuild: "We build advanced, stable, high speed, low latency WAN network to help enterprise users focus on their core business.",
      SDPlug: "Plug & Play",
      SDPlug1: "Edge connector with Plug & Play solutions",
      SDPlug2: "All the configuration is completed by the OBC cloud controller without any on-site integration",
      SDPlug3: "",
      SDAgile: "Agile & Lean Deploment",
      SDAgile1: "Fast deployment of Agile & Lean",
      SDAgile2: "Zero IT knowledge requirement for customer side.",
      SDAgile3: "Support Lay 2/3 connection, no modification to customer’s current network topology.",
      SDGlobal: "Global Coverage",
      SDGlobal1: "The OBC solutions can be deployed wherever there is Internet access",
      SDOnDemand: "On-Demand Paid with Opex Mode",
      SDOnDemand1: "Cost-efficient for customers",
      SDOnDemand2: "Hardware and software free of charge",
      SDOnDemand3: "The customer only need to pay for subscription fee.",
      SDSecure: "Secure Data Channel",
      SDSecure1: "AES256 encryption is deployed by OBC to ensure the security the customer's data in the transmission process.",
      SDHardware: "Hardware Lifetime Warranty",
      SDHardware1: "OBC commits to offer 99.9% availability and free replacement for all hardware",
      SDHardware2: "",

      // 全球应用加速
      serviceGlobalBased: "Based on OBC global distribution Cloud Nodes, your website content will be fasten published to any country or region globaly, hence it will fasten the access speed to your required website.",
      serviceGlobalSupporting: "Supporting the speed acceleration for both static resources and dynamic data interfaces at the same time, which is much better than the normal CDN performance.",
      serviceGlobalInternet: "Internet speed can be increased hundredfold while using OBC service in cross-country network visiting",
      serviceGlobalHaundredfold: "Hundredfold growth",
      serviceGlobalEffect: "Effect example",
      serviceGlobalUSA: "USA",
      serviceGlobalUSAspeed1: "Internet speed before boost: 40 K/S",
      serviceGlobalUSAspeed2: "Internet speed after boost: 13 M/S",
      serviceGlobalJapan: "Japan",
      serviceGlobalJapanspeed1: "Internet speed before boost: 50 K/S",
      serviceGlobalJapanspeed2: "Internet speed after boost: 20 M/S",
      serviceGlobalIndia: "India",
      serviceGlobalIndiaspeed1: "Internet speed before boost: 20 K/S",
      serviceGlobalIndiaspeed2: "Internet speed after boost: 17 M/S",

      // 解决方案
      solutionOur: "Our Solutions",
      solutionOBC: "OBC SD-WAN provides several professional solutions for enterprise network connection",
      solutionOffice: "Office 365 performance improvement with OBC Cloud APP Delivery solution",
      solutionGlobal: "Global private network with OBC Cloud Xpress Connect solution",
      solutionMPLS: "MPLS to OBC hybrid WAN evolution",
      solutionGlobalApp: "Global Application Deployment for enterprise OA/ERP platform acceleration",

      // 解决方案1
      solution1Office: "Office 365 performance improvement with  OBC Cloud APP Delivery solution",
      solution1Cloud: "OBC Cloud APP Delivery can offer smooth interaction of Office 365 cloud application with low-cost network connection. The network architecture of deployment is shown below :",
      solution1Application: "Application experience improvement with OBC Cloud APP Delivery",
      solution1Edge1: "OBC edge connector is deployed at each branch office, which connects the OBC cloud delivery network. And OBC’s cloud delivery network accelerates the data transmission to the Office 365’s cloud server.",
      solution1Edge2: "OBC Cloud APP Delivery solution makes a significant improvement of application experience with low latency network technology.",

      // 解决方案2
      solution2Global: "Global Private Network with OBC Cloud Xpress Connect Solution",
      solution2OBCConnection: "OBC Cloud Xpress Connect solution makes a fast and easy way to construct a global private network.",
      solution2OBCNetwork: "The network deployment topology is shown below :",
      solution2OBCCloud: "OBC Cloud Xpress Connection employs the AES-256 strong encryption to protect user data transmission worldwide, and the FastIP acceleration technology significantly improves the communication performance.",
      solution2OBCSDWAN: "By the deployment of OBC SD-WAN cloud connection, the branch offices located in different places can visit each other with virtual L2 or L3 network.",
      solution2With: "  The OPEX and CAPEX will be significantly lower than MPLS by OBC Cloud Xpress Connect",
      solution2Bandwidth: "Bandwidth Cost",

      // 解决方案3
      solution3MPLS: "MPLS to OBC Hybrid WAN Evolution",
      solution3Connection: "OBC Cloud Xpress Connect solution makes a fast and easy way to construct a global private network.",
      solution3Network: "The network deployment topology is shown below :",
      solution3AsAbove: "As the image shown above, OBC edge connector hybrids the MPLS and Internet connection together.Once the MPLS breaks down, the OBC edge switch the data to the Internet link, and the MPLS link will be monitored until it recovers.",
      solution3TheMpls: "The MPLS link works in the active state in normal case, and the Internet link keep in backup state.",
      solution3Once: "Once the MPLS breaks down, the OBC edge switch the data to the Internet links. And the MPLS link will be kept monitored until it recovers.",
      solution3ImageShow: "The image above shows the hybrid link fail-over case.",

      // 解决方案4
      solution4Using: "Using Global Application Deployment to Accelerate Enterprise OA/ERP Platforms",
      solution4Enterprise: "Once enterprise OA/ERP platforms are connected to OBC Global Application Deployment, the enterprise data resources will be quickly accessed throughout the world.",
      solution4Noneed: "No need to deploy any hardware devices, global employees can visit the domain provided by OBC global application deployment to achieve full acceleration of static resources and dynamic data.",
      solution4Application: "Application Overview",
      solution4Before: "Before acceleration : 10-20Kbps, After acceleration : 10-20Mbps",

      // 关于我们
      aboutOcean: "OCEANBLUE CLOUD",
      aboutMake: "Make Connection Easy, Make Business Agile",
      aboutWhoWeAre: "Who We Are",
      aboutAboutUs: "About Us",
      aboutWeAre: "We are OceanBlue Cloud, a leading SD-WAN provider.",
      aboutFor: "For decades, companies rely on WAN technologies (e.g. DDN, Frame Relay and MPLS) to transfer business data with high quality. Today, as cloud strucutre and hybrid structure are widely used, and demand for big data and real-time data transmission increases, traditional WAN technology is no longer able to satisfy enterprise customers, who increasingly demand faster responses and more reliable connections.",
      aboutOceanBlue: " Oceanblue Cloud(ShenZhen Ruiwang Yunlian Technology Co.,Ltd.) reckons that long-distance and high-quality real time data transmission should not be the bottleneck of business development. As such, we relied on our state-of-the-art 'Fastip' technology to help enterprise customers connect to WAN at a faster speed.",
      aboutWithOur: " With our service, customers are able to enjoy ultra-high speed, high quality data transmission service through the Internet or MPLS. In addition, OBC leverages the artificial intelligence technology to redefine the WAN by optimizing network traffic and conducting real-time network health check using distributed cloud control system, which increases the visibility of SLA.",
      aboutTianCheng: "Tiancheng Zhang",
      aboutFounder: "Founder & CEO",
      aboutTianChengExperience: "15+ years in ICT industry, CCIE, System Analyst. He has worked as senior positions in Ericsson / Huawei / Emirates Telecom and other top companies. He has deep understanding in enterprise and telecom field with excellent execution and willpower.",
      aboutYaoHua: "Yaohua Liu",
      aboutCo1: "Co-Founder",
      aboutYaoHuaExperience: "15+ years of experience in R&D, Senior architect, he had worked in Ericsson / Samsung / Nortel. He has a profound understanding in the distributed system and wealth of experience with product life-cycle management quality Control.",
      aboutLei: "Larry Wang",
      aboutCo2: "Co-Founder",
      aboutLeiExperience: "10+ years in the bottom layer of network technology development, He has a deep understanding network development technology. He has excellent understanding of the whole process from development to application.",
      aboutLocations: "Locations",
      aboutSZ: "Shenzhen, China",
      aboutSZemail: "contact@oceanbluecloud.com",
      aboutSZaddr1: "Room 601, Building A, Building E2, TCL International E City, Xili Street, Nanshan District, Shenzhen City, Guangdong Province",
      aboutHK: "Hongkong, China",
      aboutHKemail: "contact@oceanbluecloud.com",
      aboutHKaddr1: "Unit 15B, Gaoming Commercial Building 998 Canton Road, Mong Kok, HongKong",
      aboutDubai: "Dubai, U.A.E",
      aboutDubaiEmail: "contact@oceanbluecloud.com",
      aboutDubaiAddr1: "Unit No 68, Ground floor, Bldg. No.17 Dubai Internet City, Dubai UAE PO BOX 336810",
      aboutSingapore: "Singapore",
      aboutSingaporeEmail: "contact@oceanbluecloud.com",
      aboutSingaporeAddr1: "#10-09 PAYA LEBAR SQUARE SINGAPORE,",
      aboutSingaporeAddr2: "",
      aboutSingaporeAddr3: "+0065 92343288",
      aboutSingaporeAddr4: "",

      aboutSuzhou: "Suzhou, China",
      aboutSuzhouEmail: "contact@oceanbluecloud.com",
      aboutSuzhouAddr1: "Xinping Street No. 388, Ascendas iHub, Building 21, 5th Floor, Room 04.",
      aboutSuzhouAddr2: "",
      aboutSuzhouAddr3: "Tel: 0512-88982707",
      aboutSuzhouAddr4: "",

      aboutShanghai: "Shanghai, China",
      aboutShanghaiEmail: "contact@oceanbluecloud.com",
      aboutShanghaiAddr1: "Room 813, Building T2, Jingyao Qiantan, No. 308 Yaoti Road, Pudong New District, Shanghai",
      aboutShanghaiAddr2: "",
      aboutShanghaiAddr3: "Tel: 021-31836988",
      aboutShanghaiAddr4: "",

      aboutJiNan: "JiNan, China",
      aboutJiNanEmail: "contact@oceanbluecloud.com",
      aboutJiNanAddr1: "Room 1102-04, Tower C, Jinan Taiping Financial Building, Olympic Sports Financial Center, Lixia District, Jinan, Shandong, China",
      aboutJiNanAddr2: "",
      aboutJiNanAddr3: "",
      aboutJiNanAddr4: "",

      aboutUSA: "CA · USA",
      aboutUSAEmail: "contact@oceanbluecloud.com",
      aboutUSAAddr1: "3230 E IMPERIAL HWY  SUITE 300 BREA, CA 92821, USA",
      aboutUSAAddr2: "",
      aboutUSAAddr3: "",
      aboutUSAAddr4: "",

      aboutFlb: "Philippines",
      aboutFlbEmail: "contact@oceanbluecloud.com",
      aboutFlbAddr1: "18th Floor, ORE Central, 31st Street, Taguig, Metro Manila, Philippines",
      aboutFlbAddr2: "",
      aboutFlbAddr3: "",
      aboutFlbAddr4: "",

      aboutBJ: "BeiJing · China",
      aboutBJEmail: "contact@oceanbluecloud.com",
      aboutBJAddr1: "Room 12G, Chaowai MEN B Building, No. 26 Chaowai Street, Chaoyang District, Beijing",
      aboutBJAddr2: "",
      aboutBJAddr3: "",
      aboutBJAddr4: "",

      aboutBX: "Brazil",
      aboutBXEmail: "contact@oceanbluecloud.com",
      aboutBXAddr1: "Av dos Autonomistas4900, galpão C 03.0.0, km 18, Osasco-SP Brasil CEP: 06194-060",
      aboutBXAddr2: "",
      aboutBXAddr3: "",
      aboutBXAddr4: "",

      serviceUs: "Contact Us",
      serviceEmail: "Email",
      serviceTime: "Service Time",
      serviceTime2: "Monday-Friday 09:30-18:30, except holidays",
      serviceTel: "Service　Hotline",
      serviceTime3: "Service Time",
      serviceWeChat: "Scan Code Subscribe WeChat Service Account",

      // 活动页
      yunQiComputingTitle: "The Computing Conference",
      yunQiComputingContent1: "The Computing Conference is a major worldwide event in the field of cloud computing. The conference covers all the latest trends in frontier technologies, including Cloud Computing, Big Data, and AI. The event in Hangzhou event is the largest one and the focal point of the conference, held in October 2017.",
      yunQiComputingContent2: 'OceanBlue Cloud, a leading SD-WAN provider, leverages the artificial intelligence technology to redefine the WAN by optimizing network traffic and conducting real-time network health check using distributed cloud control system, which increases the visibility of SLA. We relied on our state-of-the-art "Fastip" technology to help enterprise customers connect to WAN at a faster speed.',
      yunQiDetailsTitle: "/ Details of the exhibition",
      yunQiDetailsDuring: "During the conference, we will show you our solutions and amazing services , You can experience it on the spot.",
      yunQiDetailsKeynote: "Keynote Speech:  Make business agile by deploying cloud based connection.",
      yunQiDetailsFounder: "2017-10-13   Founder&CEO -Alexann Zhang.",
      yunQiDetailsSome: "Some one-year service coupon will be sent during the conference.",
      yunQiDetailsMore: "More exciting content please continue to pay attention.",
      yunQiLocationTitle: "Oct.11-14, 2017",
      yunQiLocationContent: "Venue: D3-301,Yunqi Town International Exhibition Center, West Lake District He Shan Road, Hangzhou, China",
      yunQiExhibitionTitle: "Exhibition welfare",
      yunQiExhibitionContent1: "one-year free trial",
      yunQiExhibitionContent2: "To provide you with a service",
      yunQiExhibitionContent3: "experience",
      yunQiExhibitionContent4: "OBC is dedicated to optimizing the user's network experience.",
      yunQiExhibitionContent5: "During the conference, we have prepared our products and services for you to experience.The user who gets the coupon please click the bottom exchange button at the specified exchange date to complete the information to be used.",
      yunQiExhibitionOk: "Coupon activation",

      // 投资人
      investorTitle: "Our Investor",

      // 体验券
      yunQiOcean: "Oceanblue Cloud",
      yunQiOceanCreate: "Create a new style of intelligent network",
      couponTitle: "Free coupon activation",
      couponMessage: "You can fill in the required information here to exchange the coupon",
      couponCountry: "Your country",
      couponCompany: "Your company name",
      couponPosition: "Your title",
      couponUsername: "Name",
      couponMobile: "Phone number",
      couponEmail: "Email",
      couponCode: "Code",
      couponVerifyCode: "Verify Code",
      couponSubmit: "Submit",
      countryPlaceholder: "Please choose your region/country",
      companyPlaceholder: "Please fill in your company",
      positionPlaceholder: "Please fill in your position",
      usernamePlaceholder: "Please fill in your name",
      mobilePlaceholder: "Please fill in your phone number",
      emailPlaceholder: "Please fill in your Email",
      codeLeftPlaceholder: "Two first",
      codeCenterPlaceholder: "Two in the middle",
      codeRightPlaceholder: "Two after",
      verifyCodePlaceholder: "Verification code",

      text: "text",
      leadership: "Our Team",
      leadershipNav: "Our Team",
      leadershipTitle: "Our Team",
      leadershipSubTitle: "A happy，hard working and contagious team",

      servicePhone: "24-hour hotline: ",
      serviceContent: "7x24h, 365 Days",
      china: "(China Mainland)",
      international: "(International)",
      // 免费试用
      freeTitle: "Free Trial",
      freeHeader: "FREE TRIAL",
      freebannertitle: "GET ENTERPRISE GRADE CONNECTIVITY & APPLICATION ACCELERATION FOR YOUR GLOBAL ENTERPRISE",
      freeContentTitle: "Our Features",
      freeContentInfo: "We are a leading SD-WAN solution provider",
      freeContentMessage: "We build smart, stable, high speed, low latency WAN network to help Enterprise customers to focus on their core business",
      freePerformance: "High Performance",
      freeSecurity: "Strong Security",
      freeReliability: "High Reliability",
      freeRouting: "Smart Routing",
      freeEasy: "Easy To Use",
      freeReal: "Real-time Monitoring",
      freeAnalytics: "Data Analysis",
      freeFlexible: "Flexible Deployment",
      freeTryHeader: "Request Free Trial: ",
      freeFirstName: "First Name: ",
      freeLastName: "Last Name: ",
      freeEmail: "Email",
      freeEmailPlaceholder: "Please input your email account",
      freeFrist: "Please input your first name",
      freeLast: "Please input your last name",
      freeCompanyName: "Company Name: ",
      freeCompany: "Please input your company name",
      freeCountryName: "Region/Country:",
      freePhone: "Phone Number:",
      freeTel: "Please input your phone number",
      freeQuestion: "Do users encounter global application performance problems?",
      freeYes: "Yes",
      freeNo: "No",
      freeMore: "Tell us more",
      freeSubmit: "Submit",
      freeSuccess: "Your application has been submitted successfully!",
      freeFail: "Your application is unsuccessful, please reapply.",
      freeSubmitTitle: "An email has been sent your mailbox, please confirm!",
      freeOK: "OK",

      // 加入我们
      manage: "Expert Team",
      employee: "Company Staff",
      joinTitle: "Join Us",
      jobTitle: "Job List",
      jobEmail: "Welcome to delivery resume to:",

      // 客户端下载
      downloadHeader: "Client Download",
      downloadV1: "Latest Version Download",
      downloadV2: "V1.0 Download",
      downloadTitle: "OCEANBLUE CLOUD M100",
      downloadName: "M100 Client Download",
      downloadTip: "Universal client to enable all Oceanblue Cloud Network services",
      downloadTip2: "Great using experience on mobile and desktop devices",
      downloadTip3: "Enjoy network access on any of your devices easy and secure everywhere",
      downloadNow: "Download Now",
      downloadPoint: "Click to download",
      downloadSoon: "Open Soon...",
      downloadTip4: "Please click the “···”",
      downloadTip5: "then select another browser to open",
      downloadScreen: "Please view in the vertical screen",
      downnNetName: "NetTool Download",
      downnNetTip: "Can diagnose the network status of OBC service",
      kylin_uos: "KYLIN / UOS",
      ipsec_download: "If you need Ipsec, click to download",

      app_download: "Apps Download",
      app_download_m100: "M100 Client",
      app_new_name: "E-Connect",
      app_download_m100_tip: "The M100 Client supports VPN network access, and users can use multiple operating systems, including IOS, Android (E-Connect), Mac, Windows, Kirin/Unisys, and HarmonyOS",
      app_download_m100_tip2: "E-Connect Client supports VPN network access, and users can use the Android version.",
      app_download_go: "Go Download",
      app_sase: "SASE  Client",
      app_sase_tip: "The SASE Client supports zero-trust network access and is available for multiple operating systems including IOS, Android, Mac, Windows, and HarmonyOS",
      app_netool: "NetTool Client",
      app_netool_tip: "A Tool used to diagnose the condition of the OceanBlueCloud service",
      app_apple: "App Store Search 'M100' Download",
      download_title: "Download",
      download_ipsec: "Download (IPSec)",
      download_uos: "KYLIN/UOS",
      download_arm: "Download (Arm64)",
      download_x64: "Download (X64)",
      install_notice_title: "Installation Notice",
      install_notice_tip: "Before double-clicking to install, please allow third-party software installation in system settings.",
      install_notice_how: "How to set it up?",
      download_apple: "For Apple phones, please search 'M100' in the App Store to download.",
      download_development: "Development",
      download_apple_store: "Download (Apple)",
      download_apple_intel: "Download (Intel)",
      app_harmony: "For HarmonyOS NEXT (5.0.0) and Later Versions, Search for “鸿安通” in the App Gallery to Download.",
      harmonyOS_tip: "HarmonyOS NEXT(5.0.0) and Later Versions",

      // 设备比较
      device: "Devices",
      comparison: "Comparison",
      R200_title: "Standard 1U Carrier Level  Device",
      R200_title2: "High Performance Device with Gigabits Interfaces,",
      R200_title3: "Powerful Network Device",
      R200_intro1: "RAM",
      R200_intro2: "Operational Ability",
      R200_intro3: "Forwarding Ability",
      R200_intro4: "Size",
      R200_intro5: "Interface",
      R200_intro6: "CISCO Standard Serial x1",
      R200_intro7: "Corporate Headquarter/Large Company Branch",
      R200_intro8: "Application Scenario",
      R200_intro9: "10-300 Users",
      R200_intro10: "Number of Users",
      R200_intro11: "1U Standard Rack",
      R200_intro12: "Installation",

      // D100设备
      D100_title: "Medium Level Network Device with High Performance",
      D100_title2: "Desktop Edge Connector,",
      D100_title3: "High Network Forwarding Ability,Stable and Reliable",
      D100_intro4: "Serial x1",
      D100_intro5: "Small and Medium-sized Company/Large Company Branch",
      D100_intro6: "10-50 Users",
      D100_intro7: "Desktop/Wall Hanging",

      // S200设备
      S200_title: "Intelligent Network Device with LTE Function",
      S200_title2: "High WIFI Ability,",
      S200_title3: "Support Global LTE as WAN Connection",
      S200_intro4: "SIM,Global LTE x1",
      S200_intro5: "Small Company Branch/Retail Store",
      S200_intro6: "5-30 Users",

      // S50设备
      S50_title: "Smart Size with Powerful Function",
      S50_title2: "Perfect Fits for Small and",
      S50_title3: "Medium Level Network Deployment",
      S50_intro4: "MicroUSB Power Supply x1",
      S50_intro5: "Small Company Branch/Retail Store",
      S50_intro6: "Less than 30 Users",

      // A55设备
      A55_title: "Personal Device with Global Data Roaming",
      A55_title2: "Global E-SIM, Multi-Color",
      A55_title3: "Smart Mobile Device for Global Business Man",
      A55_intro4: "Global LTE (Built in E-SIM)",
      A55_intro5: "Small and Medium-sized Company/Soho",
      A55_intro6: "Less than 5 Users",
      A55_intro7: "Desktop/Mobile",

      // 设备比较页

      comparison_title: "Compare",
      comparison_title2: "Application Scenario、Hardware、Network Performance、Installation methods,etc.",
      downloadApp: 'AppStore Search "M100"',

      // 合作销售
      partner_title: "Cooperate Apply",
      partner_banner: "Make Connection Easy, Make Business Agile.",
      partner_banner2: "Let’s create value for customer together.",
      partner_banner3: "Sales Partners are partners who work with OBC on the SDWAN market and sell OBC products, solutions, and services to end customers.",
      partner_type: "Type",
      partner_persnal: "Personal",
      partner_company: "Company",
      partner_name: "Name",
      partner_password: "Password",
      partner_passwordAgain: "Confirm password",
      partner_photoFront: "Front Photo of ID Card",
      partner_photoBack: "Back Photos of ID Card",
      partner_upload: "Upload",
      partner_companyEmail: "Company Email",
      partner_companyName: "Company Name",
      partner_companyType: "Type of Business Registration",
      partner_companyLicense: "Company License",
      partner_companyLicense2: "Business Registration Certificate",
      partner_companyOther: "Others",
      partner_companyPhoto: "Photo of Business Registration",
      partner_companyUsername: "Username",
      partner_companyPlaceholder: "Please fill in your company name"
    },
    m: __WEBPACK_IMPORTED_MODULE_2__en_js__["a" /* default */].menu,
    ep: __WEBPACK_IMPORTED_MODULE_2__en_js__["a" /* default */].enterprise,
    vn: __WEBPACK_IMPORTED_MODULE_2__en_js__["a" /* default */].vn,
    mb: __WEBPACK_IMPORTED_MODULE_2__en_js__["a" /* default */].mob,
    dv: __WEBPACK_IMPORTED_MODULE_2__en_js__["a" /* default */].dv
  },
  ch: {
    language: {
      // 404页面
      notFoundMsg: "页面未找到",
      // header & footer
      headerServices: "服务",
      headerServicesOur: "概括",
      headerServicesDelivery: "云快递业务",
      headerServicesConnection: "云快线业务",
      headerServicesSd: "SD-WAN",
      headerServicesGlobal: "全球应用访问",
      headerSolutions: "解决方案",
      headerSolutionsOur: "概括",
      headerSolutionsSaas: "SaaS 加速",
      headerSolutionsCloud: "私有云服务",
      headerSolutionsMpls: "MPLS 混合",
      headerSolutionGlobal: "企业 OA/ERR 平台加速",
      headerAbout: "关于我们",
      aboutCompany: "关于公司",
      aboutTeam: "我们的团队",
      aboutInver: "投资人",
      headerLanguage: "English",
      headerLog: "登录",
      footerHome: "Home",
      footerService: "service",
      footerTech: "Technical Support",
      footerAbout: "about us",
      footerBack: "Back to top",

      // 主页文字
      mainWhatWan: "什么是 SD-WAN",
      mainWhatWanDefined: "软件定义的网络",
      mainWhatWanGlobal: "全球化的部署",
      mainWhatWanConnection: "提供企业专线链接",
      mainWhyWan: "为什么选择OBC",
      mainWhyWanHeight: "高性能的数据传输",
      mainWhyWanStrong: "高度的安全保护",
      mainWhyWanFlexible: "灵活的部署方式",
      mainCloud: "云快递业务",
      mainCloudSaas: "全球 SaaS 服务加速",
      mainCloudApp: "为应用数据提供保护",
      mainCloudSoho: "可弹性的部署方式",
      mainCloudRemote: "全方位实时监控",
      mainCloudConnection: "云快线业务",
      mainCloud1: "云快线业务",
      mainGlobal: "企业全球专线网络",
      mainData: "企业数据传输加速",
      mainSafeData: "安全的数据通道",
      mainSimple: "简便的部署方式",
      mainCloudBranch: "企业全球专线网络",
      mainCloudData: "企业数据传输加速",
      mainCloudSecured: "安全的数据通道",
      mainCloudEasy: "简易的部署方式",
      mainFeatures: "我们的特点",
      mainFeaturesWe: "我们是 SD-WAN 解决方案的领导者",
      mainFeaturesBuild: "我们建立先进、稳定、高速度、低延迟的WAN网络来帮助企业用户将注意力集中在他们的核心业务上。",
      mainPERFORMANCE: "高性能",
      mainPERFORMANCEDetail: "通过我们研发的FastIP技术，为不同地区间的节点提供高速的网络连接",
      mainSECURITY: "强安全",
      mainSECURITYDetail: "7*24小时保障的业务的可靠",
      mainRELIABILITY: "高可用",
      mainRELIABILITYDetail: "高强度的数据加密技术将保证数据传输过程中的私密性",
      mainSMART: "智能路由",
      mainSMARTDetail: "全球分布的中转网络，以及AI控制器组建起一个快速响应的自适应网络",
      mainEASY: "简单易用",
      mainEASYDetail: "便于使用的控制台",
      mainREAL: "实时监控",
      mainREALDetail: "实时掌握网络中各节点的状态，如有问题出现会及时发出通知",
      mainANALYTICS: "数据分析",
      mainANALYTICSDetail: "生成多种数据、报表和统计，以供企业IT人员分析使用",
      mainFlexible: "灵活部署",
      mainFlexibleDetail: "OBC产品可以被部署在任何有因特网的地方",
      mainGlobalEnterprise: "Global Enterprise Network with Connection as Service",
      mainGlobalWith: "With OBC’s Cloud connection service, it is easy and fast to deploy a global private network with branch offices in different locations.",
      mainGlobalImprove: "使用云应用快递服务提高应用效率",
      mainGlobalSaas: "使用了 OBC 云快递服务，企业云 SaaS 应用，如 office 365、Salesforce、sap 等的网络性能将至数倍以上。",
      mainWorldwide: "具有全球分布式的 SD-WAN 节点",
      mainSmart: "智能路由技术为高可用提供技术保障",
      mainShowMore: "展开以了解更多",
      mainClickShowMore: "点击以了解更多",

      // 服务
      serviceOur: "我们的产品",
      serviceWe: "进一步了解我们为您提供的产品",
      serviceCloud: "云快递业务",
      serviceSingle: "灵活的单端部署",
      serviceAcce: "加速多种 SaaS 应用",
      serviceSingleEnd: "提高特定国家或地区的访问速度",
      serviceUnderstand1: "understand more",
      serviceConnectAs: "云快线业务",
      serviceDouble: "双端或多端部署",
      serviceBuild: "核心网络创建全球私有网络",
      serviceConnectCustomer: "连接客户的云数据中心总部、分支机构",
      serviceConnectCustomer1: "以及虚拟机",
      serviceOBC: "OBC SD-WAN 解决方案",
      serviceHigh: "高性能",
      serviceStrong: "高度安全",
      serviceFlex: "部署灵活",
      serviceGlobalApp: "全球应用访问",
      serviceQuickly: "快速将您的内容分发至全球各地",
      serviceCustomer: "采用智能地域解析，将访问发布到离用户最近的地方",
      serviceSupports: "同时支持静态资源与动态数据的分布式部署",

      // 云快递
      deliveryCloud: "云快递业务",
      deliveryAccApp: "加速公有云应用，例如阿里邮箱、Office 365、Salesforce …",
      deliveryAccVM: "加速公有云虚拟机，例如阿里云ECS，亚马逊AWS，微软Azure …",
      deliveryAccService: "加速特定国家和地区的网络服务速度。",
      deliveryProblem: "我们产品解决的问题",
      deliveryHighNet: "在特定国家地区访问网络时出现的高延迟。",
      deliveryLowNet1: "从分支机构访问总部数据时的延迟。",
      deliveryLowNet2: "访问公有云应用时的迟缓响应。",
      deliveryAccNet: "在跨国网络下，网络速度提升",
      deliveryAccAll: "公有云应用访问速度提升",

      // 云快线
      connectionService: "云快线业务",
      connectionInternet: "Internet",
      connectionOBC: "OBC Overlay Cloud connection",
      connectionProvide: "Provide OBC overlay cloud connection between edge connectors",
      connectionHeadquarter: "Cloud connection between headquarter and Private Cloud nodes.",
      connectionBranches: "Cloud connection between branches and Public Cloud nodes.",
      connectionHeadquarterBranches: "Cloud connection between headquarter and branches.",
      connectionAchieve: "OBC云连接覆盖于边缘连接器之间，实现高速率低延迟的传输层第二或第三层的跨国连接",
      connectionPrivate: "在总部和私有云节点之间提供云连接。",
      connectionPublic: "在分部和公有云节点之间提供云连接。",
      connectionHead: "在总部和分部之间提供云连接。",

      // SD
      SDWhat: "为什么选择 ",
      SDWhat1: "OBC SD-WAN",
      SDWith: "随着企业宽带接入和互联网骨干网络容量的不断提高，在现有线路的基础上，SD-WAN提供了业界所寻求的低成本的网络连接方式。",
      SDTradition: "传统 MPLS 专线",
      SDInTradition: "在传统企业，电子邮件、文件分享、OA系统等应用都是通过集中部署方式实现的。",
      SDLimitations: "通常来说，在不同地区的分支机构通过MPLS专线连接到总部数据中心，其结构如下图所示：",
      SDInTradition2: "传统私有网络和MPLS专线伴随着许多限制：部署复杂、CAPEX/OPEX昂贵、且缺少灵活性。",
      SDThen: "SD-WAN 解决方案能突破以上的限制。",
      SDSDWan: "SD-WAN",
      SDEmploy: "SD-WAN是基于控制面/数据面隔离、集中管理以及其他的SDN概念上实现的技术。",
      SDEmploy2: "它有助于企业通过一个简单的操作中心在全球范围内快速部署WAN网络。",
      SDDoyou: "你是否曾经，或是否准备使用SD-WAN",
      SDPER1: "我们现在拥有SD-WAN应用",
      SDPER2: "我们在考虑使用SD-WAN",
      SDPER3: "我们不了解",
      SDPER4: "我们正在使用其他的WAN网络",
      SDPER5: "我们准备一年后使用SD-WAN",
      SDPER52: "deployment in the next 12 months",
      SDWhy: "为什么选择 OBC SD-WAN",
      SDWeBuild: "我们建立先进、稳定、高速度、低延迟的WAN网络来帮助企业用户将注意力集中在他们的核心业务上。",
      SDPlug: "即插即用的交付方式",
      SDPlug1: "所有配置全部由OBC后台控制器完成，无需现场调试",
      SDPlug2: "",
      SDPlug3: "",
      SDAgile: "智能简洁的部署",
      SDAgile1: "客户端零IT知识就可以使用",
      SDAgile2: "支持在第二三层的通信，对于客户现有的网络构造没有影响",
      SDAgile3: "",
      SDGlobal: "全球覆盖",
      SDGlobal1: "全球只要有因特网覆盖的地方，就可以部署OBC方案",
      SDOnDemand: "按需支付",
      SDOnDemand1: "为客户节省支出",
      SDOnDemand2: "软硬件均免费提供，客户只需要支付订购费用",
      SDOnDemand3: "",
      SDSecure: "安全的数据通道",
      SDSecure1: "OBC SD-WAN采用AES256加密技术全面保障客户的数据安全",
      SDHardware: "终身硬件保障",
      SDHardware1: "OBC硬件销售方保证超过99.9%的硬件可用性",
      SDHardware2: "承诺硬件终身免费更换",

      // 全球应用加速
      serviceGlobalBased: "基于OBC的全球分布节点，将您的网站发布至任意国家或地区，从而提升您的网站在全球的访问速度",
      serviceGlobalSupporting: "同时支持静态资源与动态数据接口的加速，比CDN更胜一筹。",
      serviceGlobalInternet: "使用服务后在不同国家之间做跨国访问时网速可实现",
      serviceGlobalHaundredfold: "百倍增长",
      serviceGlobalEffect: "效果实例",
      serviceGlobalUSA: "美国",
      serviceGlobalUSAspeed1: "提速前网速: 40 K/S",
      serviceGlobalUSAspeed2: "提速后网速: 13 M/S",
      serviceGlobalJapan: "日本",
      serviceGlobalJapanspeed1: "提速前网速: 50 K/S",
      serviceGlobalJapanspeed2: "提速后网速: 20 M/S",
      serviceGlobalIndia: "印度",
      serviceGlobalIndiaspeed1: "提速前网速: 20 K/S",
      serviceGlobalIndiaspeed2: "提速后网速: 17 M/S",

      // 解决方案
      solutionOur: "我们的解决方案",
      solutionOBC: "OBC SD-WAN 为企业网络连接",
      solutionOBC1: "提供了以下专业解决方案",
      solutionOffice: "基于提升OFFICE365",
      solutionOffice1: "性能的OBC云快递解决方案",
      solutionGlobal: "基于全球私有网络的OBC云快线解决方案",
      solutionMPLS: "从MPLS到OBC混合网络的演化之路",
      solutionGlobalApp: "使用全球应用部署对企业OA/ERP平台的加速",

      // 解决方案1
      solution1Office: "OBC云快递业务改进",
      solution1Office1: "Office 365性能",
      solution1Cloud: "通过OBC的云快递服务，能大大改善Office 365操作流畅度。",
      solution1Cloud1: "网络架构部署如下图所示：",
      solution1Application: "OBC云快递业务",
      solution1Application1: "提升应用体验",
      solution1Edge1: "每个分支机构都部署了OBC边缘连接器，来用于连接OBC云快递服务。",
      solution1Edge2: "OBC云快递网络加速了数据传输到Office 365云服务器的进程。",
      solution1Edge3: "OBC云快递网络利用低延迟网络技术显著提升了应用体验。",

      // 解决方案2
      solution2Global: "基于全球私有网络的",
      solution2Global1: "OBC云快线业务解决方案",
      solution2OBCConnection: "OBC云快线提供快速、简便的部署全球私有网络的解决方案。",
      solution2OBCNetwork: "以下为网络部署拓扑图",
      solution2OBCCloud: "OBC 云快线采用 AES-256 强加密方式, 保护用户数据在世界各地传输。并且，FastIP 加速显著地提高了通信性能。 ",
      solution2OBCSDWAN: " 通过OBC SD-WAN网络部署后，位于不同地区的分支机构可以通过虚拟专线L2或L3网络进行互相访问。",
      solution2With: "通过OBC云快线服务，企业的运营成本和资本性支出将会明显地下降，且远低于MPLS专线。",
      solution2Bandwidth: "宽带费用",

      // 解决方案3
      solution3MPLS: "从MPLS到OBC混合网络的演化之路",
      solution3Connection: "OBC云快线构建了一个快速、简便的部署全球私有网络的解决方案。",
      solution3Network: "网络部署的拓补结构如下：",
      solution3AsAbove: "如上图所示，OBC边缘控制器将MPLS和互联网连接进行了结合。在一般情况下，MPLS连接处于活跃状态，因特网连接处于备用状态。一旦MPLS出现异常，OBC边缘控制器将切换使用因特网连接。",
      solution3TheMpls: "同时，MPLS 连接将一直被监控，直至其恢复正常工作。",
      solution3Once: "Once the MPLS breaks down, the OBC edge switch the data to the Internet links. And the MPLS link will be kept monitored until it recovers.",
      solution3ImageShow: "The image above shows the hybrid link fail-over case.",

      // 解决方案4
      solution4Using: "使用全球应用部署对企业OA/ERP平台的加速",
      solution4Enterprise: "当企业的OA/ERP平台接入到OBC的全球应用部署方案后，在世界各地均可快速地访问企业数据资源。",
      solution4Noneed: "企业无需部署任何硬件设备，全球员工只需访问OBC全球应用部署提供的域名，即可实现静态资源与动态数据的全面加速。",
      solution4Application: "应用概览",
      solution4Before: "加速前网速范围10-20Kbps，加速后可达10-20Mbps",

      // 关于我们
      aboutOcean: "OCEANBLUE CLOUD",
      aboutMake: "使连接变得容易，使业务敏捷 ",
      aboutWhoWeAre: "我们是谁",
      aboutAboutUs: "关于我们",
      aboutWeAre: "我们是OceanBlue Cloud，领先的SD-WAN供应商。",
      aboutFor: "几十年来企业通过部署DDN, Frame Relay和MPLS等广域网技术保证其商业数据的高质量转发。近年来随着云架构DC和混合架构DC的广泛应用，同时大数据和实时商业数据传输的需求越来越多，传统的专线连接技术已经不能满足客户快速部署商业应用和连接的需求。",
      aboutOceanBlue: "Oceanblue Cloud(深圳睿网云联科技有限公司)认为远距离和实高质量的实时数据传输需求不应该成为驱动商业快速反应的瓶颈，OBC通过自有的先进Fastip技术可以帮助企业客户实现广域连接的快速部署，不管是通过Internet还是MPLS,客户都能获得超高速的高质量数据传输服务。",
      aboutWithOur: "同时OBC致力于通过人工智能重新定义广域网网络连接，通过先进的分布式云端控制器实时感知网络健康状态并调度流量，实现了SLA的可视化。",
      aboutTianCheng: "Tiancheng Zhang",
      aboutFounder: "Founder & CEO",
      aboutTianChengExperience: "15+ years in ICT industry, CCIE, System Analyst. He has worked as senior positions in Ericsson / Huawei / Emirates Telecom and other top companies. He has deep understanding in enterprise and telecom field with excellent execution and willpower.",
      aboutYaoHua: "Yaohua Liu",
      aboutCo1: "Co-Founder",
      aboutYaoHuaExperience: "15+ years of experience in R&D, Senior architect, he had worked in Ericsson / Samsung / Nortel. He has a profound understanding in the distributed system and wealth of experience with product life-cycle management quality Control.",
      aboutLei: "Larry Wang",
      aboutCo2: "Co-Founder",
      aboutLeiExperience: "10+ years in the bottom layer of network technology development, He has a deep understanding network development technology. He has excellent understanding of the whole process from development to application.",
      aboutLocations: "公司地址",

      aboutSZ: "中国 · 深圳",
      aboutSZemail: "contact@oceanbluecloud.com",
      aboutSZaddr1: "广东省深圳市南山区西丽街道TCL国际E城E2栋A栋601",

      aboutHK: "中国 · 香港",
      aboutHKemail: "contact@oceanbluecloud.com",
      aboutHKaddr1: "香港旺角廣東道998號高明商業大廈15B",

      aboutDubai: "迪拜阿拉伯联合酋长国",
      aboutDubaiEmail: "contact@oceanbluecloud.com",
      aboutDubaiAddr1: "Unit No 68, Ground floor, Bldg. No.17 Dubai Internet City, Dubai UAE PO BOX 336810",
      aboutDubaiAddr4: "",

      aboutSingapore: "新加坡共和国",
      aboutSingaporeEmail: "contact@oceanbluecloud.com",
      aboutSingaporeAddr1: "#10-09 PAYA LEBAR SQUARE SINGAPORE,",
      aboutSingaporeAddr2: "",
      aboutSingaporeAddr3: "",
      aboutSingaporeAddr4: "Tel:+0065 92343288",

      aboutSuzhou: "中国 · 苏州",
      aboutSuzhouEmail: "contact@oceanbluecloud.com",
      aboutSuzhouAddr1: "苏州工业园区新平街388号腾飞科技园21幢5层04室",
      aboutSuzhouAddr2: "",
      aboutSuzhouAddr3: "电话：0512-88982707",
      aboutSuzhouAddr4: "",

      aboutShanghai: "中国 · 上海",
      aboutShanghaiEmail: "contact@oceanbluecloud.com",
      aboutShanghaiAddr1: "上海市浦东新区耀体路308号晶耀前滩T2号楼813",
      aboutShanghaiAddr2: "",
      aboutShanghaiAddr3: "电话：021-31836988",
      aboutShanghaiAddr4: "",

      aboutJiNan: "中国 · 济南",
      aboutJiNanEmail: "contact@oceanbluecloud.com",
      aboutJiNanAddr1: "山东省济南市历下区经十路奥体金融中心C栋中国太平金融大厦11层1102-04单元",
      aboutJiNanAddr2: "",
      aboutJiNanAddr3: "",
      aboutJiNanAddr4: "",

      aboutUSA: "美国 · 加利福尼亚",
      aboutUSAEmail: "contact@oceanbluecloud.com",
      aboutUSAAddr1: "3230 E IMPERIAL HWY  SUITE 300 BREA, CA 92821, USA",
      aboutUSAAddr2: "",
      aboutUSAAddr3: "",
      aboutUSAAddr4: "",

      aboutFlb: "菲律宾",
      aboutFlbEmail: "contact@oceanbluecloud.com",
      aboutFlbAddr1: "18th Floor, ORE Central, 31st Street, Taguig, Metro Manila, Philippines",
      aboutFlbAddr2: "",
      aboutFlbAddr3: "",
      aboutFlbAddr4: "",

      aboutBJ: "中国 · 北京",
      aboutBJEmail: "contact@oceanbluecloud.com",
      aboutBJAddr1: "北京市朝阳区朝外大街26号朝外MEN B座12G",
      aboutBJAddr2: "",
      aboutBJAddr3: "",
      aboutBJAddr4: "",

      aboutBX: "巴西",
      aboutBXEmail: "contact@oceanbluecloud.com",
      aboutBXAddr1: "Av dos Autonomistas4900, galpão C 03.0.0, km 18, Osasco-SP Brasil CEP: 06194-060",
      aboutBXAddr2: "",
      aboutBXAddr3: "",
      aboutBXAddr4: "",

      serviceUs: "联系我们",
      serviceEmail: "邮箱",
      serviceTime: "服务时间",
      serviceTime2: "周一至周五 09:30-18:30,国家法定节假日除外",
      serviceTel: "客服热线",
      serviceTime3: "服务时间",
      serviceWeChat: "扫码关注企业微信服务号",
      // 活动页
      yunQiComputingTitle: "云栖大会·OCEANBLUE CLOUD",
      yunQiComputingContent1: "云栖大会已经成为全球云计算TOP级峰会，汇聚DT时代最强大脑，描绘云计算发展趋势和蓝图，展现云计算、大数据、人工智能蓬勃发展的技术生态全景。2017云栖大会将于10月继续在中国杭州云栖小镇举办，打造年度最精彩的云计算盛会。",
      yunQiComputingContent2: "睿网云联作为领先的SD-WAN供应商，致力于通过人工智能重新定义广域网网络连接，通过先进的分布式云端控制器实时感知网络健康状态并调度流量，实现了SLA的可视化。通过自有的先进Fastip技术可以帮助企业客户实现广域连接的快速部署，不管是通过Internet还是MPLS，客户都能获得超高速的高质量数据传输服务。",
      yunQiDetailsTitle: "/ 展会详情",
      yunQiDetailsDuring: "大会期间将为大家展示睿网云联的各种产品及令人惊喜的服务，并支持现场体验使用。",
      yunQiDetailsKeynote: "主题演讲: Make business agile by deploying cloud based connection",
      yunQiDetailsFounder: "2017年10月13日  Founder & CEO -Alexann Zhang",
      yunQiDetailsSome: "大会期间还将送出多份为期一年的服务体验资格给现场用户。",
      yunQiDetailsMore: "更多精彩内容请持续关注。",
      yunQiLocationTitle: "Oct.11-14, 2017",
      yunQiLocationContent: "会场地址：杭州市西湖区河山路1号云栖小镇国际会展中心D3-301",
      yunQiExhibitionTitle: "云栖大会·展会福利",
      yunQiExhibitionContent1: "为期一年的服务",
      yunQiExhibitionContent2: "提供给您免费使用体验",
      yunQiExhibitionContent3: "",
      yunQiExhibitionContent4: "睿网云联致力于优化每一位用户的网络使用体验。",
      yunQiExhibitionContent5: "大会期间为您准备了我们的产品及服务供您尽情的使用体验，获得体验券的用户请在指定兑换日期内点击下方兑换按钮，进行资料完善便可领取使用。",
      yunQiExhibitionOk: "立即兑换",

      // 投资人
      investorTitle: "我们的投资人",

      // 体验券
      yunQiOcean: "睿网云联",
      yunQiOceanCreate: "打造智慧网络新风向",
      couponTitle: "业务体验领取",
      couponMessage: "你可以在此填写所需资料以进行线上领取体验",
      couponCountry: "所在国家",
      couponCompany: "公司名称",
      couponPosition: "所在职位",
      couponUsername: "联系人",
      couponMobile: "联系方式",
      couponEmail: "邮箱",
      couponCode: "体验券号码",
      couponVerifyCode: "验证码",
      couponSubmit: "提交",
      countryPlaceholder: "请选择所在区域/国家",
      companyPlaceholder: "请填写您所在的公司",
      positionPlaceholder: "请填写您所在的职位",
      usernamePlaceholder: "请填写您的姓名",
      mobilePlaceholder: "请填写您的联系电话",
      emailPlaceholder: "请填写您的邮箱地址",
      codeLeftPlaceholder: "号码前两位",
      codeCenterPlaceholder: "号码中间两位",
      codeRightPlaceholder: "号码后两位",
      verifyCodePlaceholder: "请输入右侧验证码",

      text: "text",
      leadership: "Our Team",
      leadershipNav: "Our Team",
      leadershipTitle: "我们的团队",
      leadershipSubTitle: " 这就是我们，欢乐的团队，工作努力积极，富有感染力。",

      servicePhone: "24小时全国热线: ",
      serviceContent: "7x24h, 365天全年无休",
      china: "(中国大陆)",
      international: "(港澳台、海外)",
      freeTitle: "免费试用",
      freeHeader: "免费试用",
      freebannertitle: "为您的全球企业获得企业级连接性和应用程序加速",
      freeContentTitle: "产品特性",
      freeContentInfo: "我们是领先的SD-WAN解决方案提供商。",
      freeContentMessage: "我们构建智能、稳定、高速、低延迟的广域网，帮助企业客户专注于核心业务。",
      freePerformance: "高性能",
      freeSecurity: "高安全性",
      freeReliability: "高可靠性",
      freeRouting: "智能路由",
      freeEasy: "简单易用",
      freeReal: "实时监控",
      freeAnalytics: "数据分析",
      freeFlexible: "部署灵活",
      freeTryHeader: "免费试用: ",
      freeFirstName: "名: ",
      freeLastName: "姓: ",
      freeFrist: "名",
      freeLast: "姓",
      freeEmail: "Email",
      freeSuccess: "您的申请已提交成功!",
      freeFail: "您的申请未成功,请您重新申请.",
      freeEmailPlaceholder: "请输入您的Email账号",
      freeCompanyName: "公司名称: ",
      freeCompany: "请输入公司名称",
      freeCountryName: "所在区域/国家:",
      freePhone: "电话:",
      freeTel: "请输入您的电话号码",
      freeQuestion: "用户是否遇到全球性的应用程序性能问题?",
      freeYes: "是",
      freeNo: "否",
      freeMore: "告诉我更多",
      freeSubmit: "提交",
      freeSubmitTitle: "OceanBlue Cloud向您的邮箱发送了一封邮件,请登录邮箱确认!",
      freeOK: "确定",

      // 加入我们
      manage: "专家团队",
      employee: "公司员工",
      joinTitle: "加入我们",
      jobTitle: "职位列表",
      jobEmail: "欢迎投递简历至:",

      // 客户端下载
      downloadHeader: "客户端下载",
      downloadV1: "最新版 下载",
      downloadV2: "V1.0 下载",
      downloadTitle: "OCEANBLUE CLOUD M100",
      downloadName: "M100客户端下载",
      downloadTip: "可使用欧深网络所有服务的通用客户端",
      downloadTip2: "可支持所有主流移动及桌面设备",
      downloadTip3: "可通过任意设备享受安全便捷的网络接入",
      downloadNow: "立刻下载",
      downloadPoint: "点击下载",
      downloadSoon: "即将开放...",
      downloadTip4: "请点击右上角“···”",
      downloadTip5: "选择在浏览器中打开",
      downloadScreen: "请在竖屏下浏览",
      downnNetName: "NetTool下载",
      downnNetTip: "可诊断欧深网络服务的网络状况",
      kylin_uos: "麒麟/统信",
      ipsec_download: "如需Ipsec,点击下载",

      app_download: "应用下载",
      app_download_m100: "M100客户端",
      app_new_name: "云安通",
      app_download_m100_tip: "M100客户端支持VPN网络访问， 用户可使用多种操作系统，包括IOS, 安卓, Mac, Windows, 麒麟/统信, HarmonyOS",
      app_download_m100_tip2: "云安通客户端支持VPN网络访问， 用户可使用安卓版本",
      app_download_go: "去下载",
      app_sase: "SASE客户端",
      app_sase_tip: "SASE客户端支持零信任网络访问，用户可使用多种操作系统，包括IOS, 安卓, Mac, Windows, HarmonyOS",
      app_netool: "NetTool客户端",
      app_netool_tip: "用于诊断欧深网路服务状况的工具。",
      app_apple: "App Store 搜索 '睿连终端M100' 下载",
      download_title: "下载",
      download_ipsec: "下载 (IPSec)",
      download_uos: "麒麟/统信",
      download_arm: "下载 (Arm64)",
      download_x64: "下载 (X64)",
      install_notice_title: "安装须知",
      install_notice_tip: "双击安装软件前请先在系统设置里设置允许第三方软件安装",
      install_notice_how: "如何设置？",
      download_apple: "苹果手机请在App Store搜索 '睿连终端M100' 下载",
      download_development: "研发中",
      download_apple_store: "下载 (Apple)",
      download_apple_intel: "下载 (Intel)",
      app_harmony: "鸿蒙NEXT(5.0.0)及以上版本通过应用市场搜索“鸿安通”下载",
      harmonyOS_tip: "鸿蒙NEXT(5.0.0)及以上版本",

      // 设备比较
      device: "硬件设备",
      comparison: "机型比较",

      // R200设备
      R200_title: "标准1U的运营商级设备",
      R200_title2: "超高转发性能",
      R200_title3: "极速千兆网口  稳定组网",
      R200_intro1: "内存",
      R200_intro2: "业务能力",
      R200_intro3: "转发能力",
      R200_intro4: "设备尺寸",
      R200_intro5: "接口",
      R200_intro6: "思科标准串口 x1",
      R200_intro7: "企业总部 / 大型企业分支机构",
      R200_intro8: "应用场景",
      R200_intro9: "10-300人",
      R200_intro10: "建议使用人数",
      R200_intro11: "1U 标准机架安装",
      R200_intro12: "安装方式",

      // D100设备
      D100_title: "高性能中小型组网设备",
      D100_title2: "桌面型边缘连接器",
      D100_title3: "高转发性能，稳定可靠",
      D100_intro4: "串口 x1",
      D100_intro5: "中小型企业 / 大型企业分支机构",
      D100_intro6: "10-50人",
      D100_intro7: "桌面/墙挂",

      // S200设备
      S200_title: "具备LTE功能的组网终端",
      S200_title2: "高性能WIFI",
      S200_title3: "支持全球LTE作为WAN接入",
      S200_intro4: "SIM/全球 LTE x1",
      S200_intro5: "小型企业分支 / 零售门店",
      S200_intro6: "5-30人",

      // S50设备
      S50_title: "精巧体积下的澎湃性能",
      S50_title2: "完美适配小型组网场景的",
      S50_title3: "智能设备",
      S50_intro4: "MicroUSB 电源接口 x1",
      S50_intro5: "小型企业分支 / 零售门店",
      S50_intro6: "小于30人",

      // A55设备
      A55_title: "全球漫游的个人智能设备",
      A55_title2: "全球E-SIM, 多色可选",
      A55_title3: "全球商旅人士的便携智能设备",
      A55_intro4: "全球漫游LTE (内置E-SIM)",
      A55_intro5: "中小型企业/连锁机构或SoHo",
      A55_intro6: "小于5人",
      A55_intro7: "桌面/手持",

      // 设备比较页

      comparison_title: "机型比较",
      comparison_title2: "应用场景、硬件参数、性能参数、安装方式等介绍",
      downloadApp: 'AppStore 搜索 "睿连终端M100"',

      // 合作销售
      partner_title: "合作申请",
      partner_banner: "Make Connection Easy, Make Business Agile.",
      partner_banner2: "让我们一起实现客户价值",
      partner_banner3: "销售合作伙伴在行业或区域内从事OBC产品和解决方案销售.",
      partner_type: "合作类型",
      partner_persnal: "个人",
      partner_company: "企业",
      partner_name: "姓名",
      partner_password: "密码",
      partner_passwordAgain: "确认密码",
      partner_photoFront: "身份证正面照片",
      partner_photoBack: "身份证反面照片",
      partner_upload: "上传",
      partner_companyEmail: "企业邮箱",
      partner_companyName: "企业名称",
      partner_companyType: "营业登记类型",
      partner_companyLicense: "营业执照",
      partner_companyLicense2: "商业登记证",
      partner_companyOther: "其他",
      partner_companyPhoto: "营业登记图片",
      partner_companyUsername: "联系人",
      partner_companyPlaceholder: "请输入企业名称"
    },
    m: __WEBPACK_IMPORTED_MODULE_3__ch_js__["a" /* default */].menu,
    ep: __WEBPACK_IMPORTED_MODULE_3__ch_js__["a" /* default */].enterprise,
    vn: __WEBPACK_IMPORTED_MODULE_3__ch_js__["a" /* default */].vn,
    mb: __WEBPACK_IMPORTED_MODULE_3__ch_js__["a" /* default */].mob,
    dv: __WEBPACK_IMPORTED_MODULE_3__ch_js__["a" /* default */].dv
  }
};
// Create VueI18n instance with options
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: "en", // set locale
  messages: messages // set locale messages
}));

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MainPage__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MainPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MainPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_path__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_path__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // 前进后腿返回原始位置，history模式可用
    } else {
      return { x: 0, y: 0 }; // 路由跳转返回顶部，history模式可用
    }
  },

  routes: [{
    path: "/",
    name: "MainPage",
    component: __WEBPACK_IMPORTED_MODULE_3__components_MainPage___default.a
  }, {
    path: "*",
    name: "NotFound404",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(133)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/video",
    name: "video",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(166)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/services",
    name: "ServicesPage",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(160)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/product/delivery",
    name: "DeliveryPage",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(155)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/product/connection",
    name: "ConnectionPage",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(154)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/services/sdwan",
    name: "SdwanPage",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(159)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/product/global",
    name: "GlobalAppPage",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(158)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/product/mobility",
    name: "MoblieClient",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(129)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/solutions",
    name: "SolutionsPage",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(165)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/solutions/enterprise",
    name: "Enterprise",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(125)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/solutions/virtualNetwork",
    name: "VirtualNetwork",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(135)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/solutions/saas",
    name: "SaaSPage",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(164)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/solutions/cloud",
    name: "CloudPrivatePage",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(161)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/solutions/mpls",
    name: "MplsPage",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(163)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/solutions/global",
    name: "GlobalSolutionPage",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(162)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/about",
    name: "AboutUs",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(121)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/news",
    name: "News",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(132)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/leader-ship",
    name: "Leadership",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(128)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/investor",
    name: "Investor",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(152)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/free-trial",
    name: "FreeTrial",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(126)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/partner-apply",
    name: "PartnerApply",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(134)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/free-application",
    name: "FreeApplication",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(127)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/yunqi",
    name: "YunQiCoupon",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(137)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/yunqi/coupon",
    name: "CouponApply",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(136)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/join",
    name: "JoinUs",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(153)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/expert",
    name: "expert",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(151)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/award",
    name: "awards",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(123)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/services/download",
    name: "download",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(156)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { path: "/Download", redirect: "/services/download" }, {
    path: "/services/download/m100",
    name: "downloadM100",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(27)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { path: "/Download-M100", redirect: "/services/download/m100" }, {
    path: "/services/download/sase",
    name: "downloadSASE",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(29)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { path: "/Download-YAT", redirect: "/services/download/yat" }, {
    path: "/services/download/yat",
    name: "downloadYAT",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(157)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { path: "/Download-Sase", redirect: "/services/download/sase" }, {
    path: "/services/download/netool",
    name: "downloadNetool",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(28)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { path: "/Download-Tool", redirect: "/services/download/netool" }, {
    path: "/services/download/m100",
    name: "downloadM100",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(27)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/services/download/sase",
    name: "downloadSASE",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(29)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/services/download/netool",
    name: "downloadNetool",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(28)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/android",
    name: "android",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(122)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/technology/download",
    name: "Download",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(124)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  //新闻详情

  {
    path: "/NewDetail/1",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(130)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/NewDetail/2",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(131)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },

  // 设备详情
  {
    path: "/services/device/R100-X6",
    name: "device",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(142)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    children: [{
      path: "/",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(143)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: "/services/device/R200-X6",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(145)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: "/services/device/R500-X8S",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(146)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: "/services/device/A55",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(138)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: "/services/device/D100-AWL5",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(140)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: "/services/device/D200-X4",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(141)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: "/services/device/V100",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(149)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    },
    // 下面是不用的
    {
      path: "/services/device/R200",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(144)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: "/services/device/D100",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(139)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: "/services/device/S200",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(147)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: "/services/device/S50",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(148)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: "/services/device/comparison",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(150)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }]
  }]
}));

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(112),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);

var vueObject = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({});
/* harmony default export */ __webpack_exports__["a"] = (vueObject);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/videoInit.1c70a26.png";

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(15);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_about_videoInit_png__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_about_videoInit_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_about_videoInit_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      language: this.getLanguage(),
      isShow: false,
      videoUrl: "https://minio.oceanbluecloud.com/redio/mov.mp4",
      videoInit: __WEBPACK_IMPORTED_MODULE_2__assets_about_videoInit_png___default.a
    };
  },

  components: {
    AppFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer_vue___default.a,
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components_Header_vue___default.a
  },
  mounted: function mounted() {
    this.is_iPad();
  },

  methods: {
    scrollChange: function scrollChange() {
      this.baseHeight = (document.body.scrollTop || window.pageYOffset) + window.innerHeight - this.headHeight;
      if (typeof this.$refs.currentPage.upAnimation == "function") {
        this.$refs.currentPage.upAnimation(this.baseHeight);
      }
    },
    getLanguage: function getLanguage() {
      localStorage.language = ["ch", "en"].indexOf(localStorage.language) > -1 ? localStorage.language : navigator.language == "zh-CN" ? "ch" : "en";
      this.$parent._i18n.locale = localStorage.language;
      return localStorage.language;
    },

    // video
    closeVideo: function closeVideo() {
      this._dom = document.getElementById("myvideo");
      this._dom.pause();
      this.isShow = false;
      // location.reload();
    },
    playVideoFn: function playVideoFn(data) {
      if (data == "play") {
        this.isShow = true;
        this._dom = document.getElementById("myvideo");
        this._dom.play();
      }
    },
    is_iPad: function is_iPad() {
      if (navigator.userAgent.match(/(pad|pod|iPod|iPad Phone)/i)) {
        this.videoUrl = "https://minio.oceanbluecloud.com/redio/webMov.mp4";
      }
    }
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Footer',
  data: function data() {
    return {};
  },

  methods: {
    //      toTop: function(){
    //        window.scrollBy(0,-100);
    //        var timer = setTimeout(()=>{
    //          this.toTop();
    //        },10)
    //        if(document.body.scrollTop + document.documentElement.scrollTop == 0){
    //            clearTimeout(timer)
    //        }
    //      }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_js__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Header",
  props: ["language"],
  data: function data() {
    return {
      lang: "",
      isWeChat: false
    };
  },

  methods: {
    routerClickFn: function routerClickFn() {
      $("body").css("overflow", "");
      this.hideFirstMenu();
    },
    showFirstMenu: function showFirstMenu(e) {
      //高度与标签个数有耦合ssss
      $("header").addClass("header-show-menu");
      $(".menu-contain").outerHeight(window.innerHeight - $(".header-contain").outerHeight());
    },
    hideFirstMenu: function hideFirstMenu(e) {
      $("header").removeClass("header-show-menu");
      $(".first-item").removeClass("show-second-menu");
      $(".menu-contain").outerHeight(0);
    },
    toggleSecondMenu: function toggleSecondMenu(event) {
      $(event.event.target).closest(".first-item").toggleClass("show-second-menu");
    },
    changeLanguage: function changeLanguage() {
      localStorage.language === "en" ? localStorage.setItem("language", "ch") : localStorage.setItem("language", "en");
      this.$parent._i18n.locale = localStorage.language;
      this.$parent.language = this.$parent._i18n.locale;
      // this.$router.push({ path: "/" });
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].$emit("langChange", this.$parent._i18n.locale);
      this.hideFirstMenu();
      this.initUdesk();
    },
    initUdesk: function initUdesk() {
      (function (a, h, c, b, f, g) {
        a["UdeskApiObject"] = f;
        a[f] = a[f] || function () {
          (a[f].d = a[f].d || []).push(arguments);
        };
        g = h.createElement(c);
        g.async = 1;
        g.charset = "utf-8";
        g.src = b;
        c = h.getElementsByTagName(c)[0];
        c.parentNode.insertBefore(g, c);
      })(window, document, "script", "//assets-cli.udesk.cn/im_client/js/udeskApi.js", "ud");
      ud({
        code: "25972ccj",
        link: "//oceanbluecloud.udesk.cn/im_client/?web_plugin_id=41861",
        language: this.$parent._i18n.locale == "en" ? "en-us" : "zh-cn",
        pos_flag: "crb"
      });
    }
  },
  mounted: function mounted() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.isWeChat = true;
    } else {
      this.isWeChat = false;
      this.initUdesk();
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__independent_Swiper_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__independent_Swiper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__independent_Swiper_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MainPage",
  components: {
    AppSwiper: __WEBPACK_IMPORTED_MODULE_0__independent_Swiper_vue___default.a
  },
  props: ["language"],
  data: function data() {
    return {
      scrollHeight: 0,
      minHeight: 0,
      maxHeight: 0
    };
  },

  methods: {
    showTabDetail: function showTabDetail(event) {
      $(event.event.target).closest(".outer-item").toggleClass("show-detail");
    },
    showFeaturesDetail: function showFeaturesDetail(event) {
      $(".feature-section").addClass("show-detail");
    },
    hideFeaturesDetail: function hideFeaturesDetail(event) {
      $(".feature-section").removeClass("show-detail");
    },
    scrollChange: function scrollChange() {
      this.minHeight = $(".banner").outerHeight() + $(".tab-section").outerHeight() + $(".gradient").outerHeight() - $(".gradient .classify-detail").outerHeight();
      this.maxHeight = this.minHeight + $(".feature-section .feature-detail").outerHeight();
      this.scrollHeight = document.body.scrollTop || window.pageYOffset;
      if (this.minHeight < this.scrollHeight && this.scrollHeight < this.maxHeight - 100) {
        $(".feature-detail .classify-contain .icon-box").addClass("for-position");
      } else {
        $(".feature-detail .classify-contain .icon-box").removeClass("for-position");
      }
    },
    jumpRouter: function jumpRouter() {
      var top = $(".sdwan-page").height() - $(".section6").height();
      window.scroll(0, top);
    }
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.scrollChange);
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "carrousel",
  props: ["language"],
  data: function data() {
    return {
      swiperOption: {
        // NotNextTick is a component's own property, and if notNextTick is set to true, the component will not instantiate the swiper through NextTick, which means you can get the swiper object the first time (if you need to use the get swiper object to do what Things, then this property must be true)
        // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        //          notNextTick: true,
        loop: true, // 必须在autoplay之前
        // swiper configs 所有的配置同swiper官方api配置
        autoplay: 2000,
        autoplayDisableOnInteraction: false,
        // direction : 'vertical',
        effect: "slide",

        //          grabCursor : true,
        setWrapperSize: true,
        autoHeight: true,
        // paginationType:"bullets",
        pagination: ".swiper-pagination",
        paginationClickable: true,

        // scrollbar:'.swiper-scrollbar',
        //          mousewheelControl : true,
        observeParents: true
        // if you need use plugins in the swiper, you can config in here like this
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        // debugger: true,
        // swiper callbacks
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        // onTransitionStart(swiper){
        //   console.log(swiper)
        // },
        // more Swiper configs and callbacks...
        // ...
      }
    };
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  },
  // you can find current swiper instance object like this, while the notNextTick property value must be true
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper: function swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted: function mounted() {
    // you can use current swiper instance object to do something(swiper methods)
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    // console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: { type: String, default: "info" },
    message: { type: String, required: true },
    duration: { type: Number, default: 3000 }
  },
  data: function data() {
    return { timer: null };
  },
  mounted: function mounted() {
    this.startTimer();
  },

  methods: {
    startTimer: function startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(this.close, this.duration);
      }
    },
    clearTimer: function clearTimer() {
      clearTimeout(this.timer);
    },
    close: function close() {
      this.$emit("close");
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__message_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__message_vue__);




var MessageConstructor = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_2__message_vue___default.a);

var instances = [];
var seed = 1;
var verticalOffset = 50;

var Message = function Message() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (typeof options === "string") {
    options = { message: options };
  }

  var id = "message_" + seed++;
  var instance = new MessageConstructor({
    propsData: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options)
  });

  // 先关闭所有现有 message
  instances.forEach(function (inst) {
    if (inst && typeof inst.close === "function") {
      inst.close(); // 触发组件的 close 事件
    }
  });

  instance.$mount();
  document.body.appendChild(instance.$el);

  instance.$on("close", function () {
    closeMessage(id);
  });

  instance._id = id;
  instance.$el.style.top = verticalOffset + "px";
  verticalOffset += instance.$el.offsetHeight + 16;
  instances.push(instance);

  return instance;
};

function closeMessage(id) {
  var index = instances.findIndex(function (inst) {
    return inst._id === id;
  });
  if (index === -1) return;

  var removed = instances.splice(index, 1)[0];
  verticalOffset -= removed.$el.offsetHeight + 16;
  document.body.removeChild(removed.$el);

  // 更新后面 message 的位置
  for (var i = index; i < instances.length; i++) {
    var el = instances[i].$el;
    var top = parseInt(el.style.top) - removed.$el.offsetHeight - 16;
    el.style.top = top + "px";
  }
}

/* harmony default export */ __webpack_exports__["a"] = (Message);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export menu */
/* unused harmony export enterprise */
/* unused harmony export vn */
/* unused harmony export mob */
/* unused harmony export dv */
//菜单
var menu = {
  enterprise: "企业",
  vn: "多点组网",
  product: "产品",
  mobility: "移动应用",
  technology: "技术",
  download: "资料下载",
  aboutUs: "关于我们",
  awards: "奖项",
  news: "新闻资讯"
};

var enterprise = {
  t: "企业的IT服务正逐步向混合云迁移",
  c: "业务虚拟化已有比较成熟的方案，但网络连接只完成了局域网虚拟化，广域网连接仍停留在传统模式。广域网连接虚拟化，需要数据的控制，面向统一管理、调度、配置，数据的转发面向资源的集中和分享。",
  t1: "基于SD WAN架构的广域网部署，协助企业混合组网",
  c1: "通过多类型 SD-WAN CPE，经Internet连接云端POP点，实现快速、便捷、高质量、低成本混合组网。支持传统广域网组网向 SD-WAN 平滑演进，保护现有投资和业务一致性同时，助力企业数据中心逐步向云端迁移。",
  t2: "SD-WAN云快线解决方案 - 智能广域网",
  c2: "国内外分公司/分支机构/客户总部/数据中心之间的企业跨境组网，对应专线或MPLS，实现国内3层连接的高速低延迟混合云互联，建议每路高清会议使用4M及以上带宽，企业内部组网后，所有数据在内网传输，AES256 加密可保证数据安全，支持混合组网，充分利用现有投资，支持低成本扩展，SD-WAN集中控制系统，可将配置与安全策略统一推送到各接入点。",
  kt: "降低成本",
  kt1: "高质量",
  kt2: "快递交付",
  kt3: "易管理",
  kt4: "高可用",
  kt5: "灵活性",
  kc: "相比现有 MPLS/专线方案成本与 TCO 降低 80%",
  kc1: "整体组网基于 SD-WAN技术，可以有效保证线路稳定性",
  kc2: "一周之内开通业务，分支机构零配置",
  kc3: "全球分支机构统一管理配置、统一监控网络情况",
  kc4: "所有分支机构采用主备方案",
  kc5: "对比MPLS/专线，有更强的虚拟化能力，支持更丰富快速的组网方案"
};

//多点组网
var vn = {
  t: "多点组网解决方案",
  c: "办公点只需要连接公网，即可组网，分支地区通过专线或宽带直接接入SD-WAN骨干接入点，西北地区使用 FastIP 技术优化公网传输后接入华中接入点或云中继点，省内使用 FastIP 技术优化公网传输后直连总部，支持设备与链路级的主备或双活模式。",
  cc: "无需更改现有系统架构，无需预先投资任何固定资产，节约建设与维护成本，在不增加成本的前提下，通过算法优化传输质量，部署周期快，全网统一可视化管理，支持混合组网，充分利用现有资源，AES-256 强加密方式，保证客户数据安全。",
  t1: "分支店面组网架构",
  c1: "支持多种接入模式，LTE，宽带及MPLS。根据各个分支机构使用不同类型设备支持不同的用户量。分支门店使用S/D系列设备。总部使用R设备。"
};

//移动应用
var mob = {
  t: "多平台客户端应用程序，提升移动办公、远程办公效率",
  c: "我们有windows、mac、android、ios等多平台客户端程序，可使用欧深网络所有服务的通用客户端，可支持所有主流移动及桌面设备，可通过任意设备享受安全便捷的网络接入",
  f: "使用服务后可在不同国家间做跨国高速访问",
  f1: "支持多种桌面与移动系统",
  f2: "一键登录高速安全的加密链路",
  f3: "支持企业账户无缝对接",
  go: "前往下载"
};
//设备
var dv = {
  //rx
  rxs: "标准1U",
  rxu: "人",
  rxesim: "内置esim",
  rxno: "无",
  rxv100: "根据云主机配置",
  rxv100a: "云主机虚拟镜像",
  rxv100u: "公有云/私有云主机",
  rxv100t: "虚拟设备",
  rxv100t1: "虚拟边缘连接器",
  rxv100t2: "适用公有云 私有云平台",
  dtt: "高性能中小型设备"
};

/* harmony default export */ __webpack_exports__["a"] = ({ menu: menu, enterprise: enterprise, vn: vn, mob: mob, dv: dv });

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export menu */
/* unused harmony export enterprise */
/* unused harmony export vn */
/* unused harmony export mob */
/* unused harmony export dv */
//菜单
var menu = {
  enterprise: "Enterprise",
  vn: "Virtual Network",
  product: "Product",
  mobility: "Mobility",
  technology: "Technology",
  download: "Download",
  aboutUs: "About Us",
  awards: "Awards",
  news: "News"
};
//企业
var enterprise = {
  t: "Enterprise IT services are gradually migrating to hybrid cloud",
  c: "There are relatively mature solutions for business virtualization, but the network connection only completes the local area network virtualization, and the WAN connection remains in the traditional mode. WAN connection virtualization requires data control, which is oriented toward unified management, scheduling, and configuration, and data forwarding is oriented toward resource concentration and sharing.",
  t1: "Wide area network deployment based on SD WAN architecture to assist enterprise hybrid networking",
  c1: "Through multi-type SD-WAN CPE, connect to the cloud POP point via the Internet, realize fast, convenient, high-quality, low-cost hybrid networking. Support the smooth evolution of traditional WAN networking to SD-WAN, protect existing investments and business consistency, and help enterprise data centers to gradually migrate to the cloud.",
  t2: "SD-WAN Cloud Express Solution-Smart WAN",
  c2: "Enterprise cross-border networking between domestic and foreign branches/branch offices/customer headquarters/data centers, corresponding to dedicated lines or MPLS, to achieve high-speed and low-latency hybrid cloud interconnection with domestic 3-layer connections. It is recommended that each channel of high-definition conferences use 4M and above bandwidth , After the company’s internal networking, all data is transmitted on the internal network, AES256 encryption can ensure data security, support hybrid networking, make full use of existing investments, support low-cost expansion, SD-WAN centralized control system, configuration and security strategies can be combined Unified push to all access points.",
  kt: "Lower The Cost",
  kt1: "High Quality",
  kt2: "Express Delivery",
  kt3: "Easy To Manage",
  kt4: "High Availability",
  kt5: "Flexibility",
  kc: "Compared with the existing MPLS/dedicated line solution, the cost and TCO are reduced by 80%",
  kc1: "The overall network is based on SD-WAN technology, which can effectively ensure line stability",
  kc2: "Open business within one week, zero configuration of branches",
  kc3: "Unified management and configuration of global branches and unified monitoring of network conditions",
  kc4: "All branches adopt the master-backup solution",
  kc5: "Compared with MPLS/dedicated line, it has stronger virtualization capabilities and supports richer and faster networking solutions"
};

//多点组网
var vn = {
  t: "Virtual Network solution",
  c: "Office points only need to be connected to the public network to form a network. Branch areas are directly connected to SD-WAN backbone access points through dedicated lines or broadband. The Northwest region uses FastIP technology to optimize public network transmission and then connects to Central China access points or cloud relays. Point, the province uses FastIP technology to optimize public network transmission and then directly connects to the headquarters, supporting equipment and link-level active-standby or dual-active mode.",
  cc: "No need to change the existing system architecture, no need to invest in any fixed assets in advance, save construction and maintenance costs, optimize transmission quality through algorithms without increasing costs, fast deployment cycle, unified visual management of the entire network, support for hybrid networking, and fully Use existing resources and AES-256 strong encryption to ensure the security of customer data.",
  t1: "Branch storefront network architecture",
  c1: "Support multiple access modes, LTE, broadband and MPLS. Supports different user volumes based on different types of equipment used by various branches. Branch stores use S/D series equipment. The headquarters uses R equipment."
};

//移动应用
var mob = {
  t: "Multi-platform client application to improve the efficiency of mobile office and remote office",
  c: "We have multi-platform client programs such as windows, mac, android, ios, etc., which can use the universal client of all services of Europe-Shenzhen, and can support all mainstream mobile and desktop devices, and can enjoy safe and convenient network access through any device",
  f: "After using the service, you can do cross-border high-speed access between different countries",
  f1: "Support multiple desktop and mobile systems",
  f2: "One-click login high-speed and secure encrypted link",
  f3: "Support seamless docking of corporate accounts",
  go: "go to download"
};

//设备
var dv = {
  //rx
  rxs: "Standard 1U",
  rxu: "Users",
  rxesim: "Built-in esim",
  rxno: "N/A",
  rxv100: "According to cloud configuration",
  rxv100a: "Cloud Virtual image",
  rxv100u: "Public Cloud/Private Cloud",
  rxv100t: "Virtual device",
  rxv100t1: "Virtual Edge Connector",
  rxv100t2: "Applicable public cloud private cloud platform",
  dtt: "High-performance small and medium-sized equipment"
};

/* harmony default export */ __webpack_exports__["a"] = ({ menu: menu, enterprise: enterprise, vn: vn, mob: mob, dv: dv });

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_tap__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_tap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_tap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_message_index__ = __webpack_require__(17);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// 👇 这里是新增的：引入 message 插件


// 配合expose-loader，全局导入jQuery
__webpack_require__(20);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_v_tap___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: "v-touch" });

// 👇 注册 message 插件
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__components_message_index__["a" /* default */]);

var GlobalVue = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: "#app",
  i18n: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  data: {
    language: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].locale
  }
});

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_img_01@3x.ea19ff0.jpg";

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_img_02@3x.fc21285.jpg";

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_img_03@3x.38f699b.png";

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCBAMAAAAReh3bAAAAKlBMVEUAAAAAAADj4+MAAAAAAAAAAAAAAAAAAAAAAAAzMzPy8vIAAAD39/f///+z12ltAAAADXRSTlMzALAtBx8bDyk80hLiKXcjUAAAAYFJREFUSMeVljFPg0AYht9IITV1IUBw7B9oQlOjK8Q/AJOOJI5OxLjj4O7s6ObWyR/iaMp/EVvgu+Pg3vhOl+bpk7vj7vsOvpLw636H3etjpv6oEs8JTnHuJonwAZLrzCTCHGrczCBK6PHGxBPGudGJCGYKlQhrmFlmCnGLqVwJESeThFN1hChMSUeEohhJso64xFxeOiKfJdwTEWM+1ZEILMT2SJQWwvsjQtiStURkJYqWSK3EoiVKK+G1xLChb4A5dHwMu3H+gT5nnwJXGCb63qzRZfMjkgLB8MfmW0bKnkGWsmnWMpDFYA9FYiqwQglVYijgIYcqMRRwUUOTjBVYIoEmGSvgdIRIeoUQgCY5iEKiS3qFRL8JF80BGM+DOBzUZB5L5GQtLkqyHx72ZE9XSMl3WSAg33aLiJyPAjE5YxX8xHpOHblRxlmXG5XO3Be5lZH1zhW8OtAKw6sUr3S0WvKKy6s2rfy8e9AOxLsY7YS0m9KOzLs6fRn843XBXyi/mgeCuF0ws6UAAAAASUVORK5CYII="

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAMAAADUivDaAAAAY1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+aRQ2gAAAAIHRSTlMAgPkdBeSN7MDmzZqHX05BPDgR9d/aubaolFlYKiQMNi7YzokAAAHSSURBVFjDnJPbkoIwEESbJIByE1AQxUv//1fuJNZWmV2ikPOYUIeZngyC6DmZilOuVH4qpmTW2MihHPiHoTxgNbpKuUharavlXipajmNVd7o3ptddXY1HWlR5xzcemRPss9bAw7TZ3kmyBz7SuBZ2jcECptm5dhqEMRcnaBGkdZKLCcZY2Bau+MjVtlMEYr3ZJs49vtCfbTM3LPDM5SrDCjKS+XOhBjGoGquolTj+1aFTOe2wki6XXjQ8TCE1iGG1Q0mm/lzsNGtsoLaz9V6Un+TaTJu3V53KNLGRs8TxeDfu+8DWJ0lgx/v9W+V3ySb0JhMyCb1TmcDv3payF9iugOxLCYeWItoYRStlaFgqW0SEwpVRwZLKdOIUjQzFZS7jMHEKI0M5vMLMEKdA9gp0kDBjFRLoAGjyaGIV5khqzOSIWAVGcrbfVPGKyl5PZB2vqMkJBdnFKzqywEkCiVdo8oSc7P3t9tiRO//k4G08mUORxv/tZ/yiDKl+WrEDGgBAGIiB/l1XxNUACbDt2x1H+EWO5/RPPUrLC/xoM292HznP4PPx6yHgUeSB6LE8wYEjioOS45pDo6OrA7RjvMuEK42LleudS6arrgu3a/+/fPAVSC2RU/Eq+vrEAAAAAElFTkSuQmCC"

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABjCAMAAAAyytfmAAAArlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8tivQqAAAAOXRSTlMA6OL75Q323PLwKDIHyuwsJIASta+VcDwb1tCpkYxpQR/qpntQS0Y3FgTAYS/Eh4OemXRkV72jd1oCuXbXAAADuElEQVRo3u2Z2ZKqMBBAo2EXBARX3FfUcV/m9v//2A0xNTjOMAmQR8+DUiYcG7rToQokino8qkgyNR1AX0lV2nsMBLy35TmXOjD0hSSlF1LfZEK/Ak+CstHHVDaN4yk9wP1GSaXqG9TUXT7dBuNQRtvw69Rinm2WsE/z8YNfVNsZPKLEzTj9MW7iR7T9cQHlKMIP5dR7yduUDYSjnEGee8CU1s9Ri2mhe+4IGy83dpLW9DKqrKmxP71d+N7GYtADhuLH2RNjXwFGd7DISpttzWdTHb7YXNfoT9bXTTpbn87mVrqG/ebpOA0cBZ7pzoRyO5514ZlKL4iOp+YBVeEFvPt0kTDWeYNfDZXvUmO3X6i5V91yvzF+lU6cyL9aqDDW1Y+cyZO0XhvbkvruuFZn0gqSiPKWvqVv6Vv6lkqhWlrqOZZ0qadAxZIstZRkl3OlSq0KJAxkSpnzKPPy3YfzJDNR7oQ6mzJL6iN1SpPW6tTZ5xS/HCdfqm6znCarpfxSdQf+rwOr1JlXqjrkRD/buUcFpDdIOKBX2iYb4ErFA2obzMmXCluZ00fCUn5CRg/nDAlL+eU40phTWMq3Mudnye3ko/60xJcP5xnxpV0Ak984UmcL/Q3piDrakYk2t8Wd0ELMiTCAg0Iys8NvxgEWczaSuehEPmvcbYMx5DdvMuuOWty5liLuRBdaHivyGXG3d8oF8bmTeW20JglQEMdaFXUiHQCTvG/oTeVaMWvZ/FvqkO8WrUMOY13IiQZsxcUYoG7zZttCzjWpFEwLNCD2f0gKc6K60aMrOerKkfa+4lvr9FBSoNU1omyTUNeSAh0ilIbaKu8cJoGSjKahGp2yzo75bSXT/heWlUa08FNcTHNVOku49roSDK+Mc2z+eGRTu+Snnl3cuXaIQFdfNiONbhqF6bOL/1kP4nXFPztNHp4Xcy4wLZ+MZ0dtVcRZM5KMqL8NxUl/Nzn9OvORo5qxeKykKuq5rW7iND6yhttGbit7iNFGCP1pNZZ5nCOTOTlWnGPBXjHHSa119qQsxgwIJvclikX3+FAVUaohEKouf2bsAEEXmOnSVwe9jtD/R0DQzrx5LU3wmth0TN+ejP9sdfTNCc7RLVZVGuwssxfaMxqm0kY5UI+QoM8zGohOh++NvI3n8fzo/KKdO0DDLPBiVh1goNkdfounMeyVen3qhUDRoq3HsrONNKAEFipKOwBGxQkCpwKMoI3K4N41eEG7f6CyqNsbTo14c1GRFNTlIdzp+i48LIWM/wEtfPiYXZ2CJAAAAABJRU5ErkJggg=="

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABmCAMAAABflSczAAAAsVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+3mHKcAAAAOnRSTlMA+0yzFlX21Q3q5GvxxpsG0kEcEpTbIr64YUYD38o7e00mcDUw583COIDuoImFdh6rppZmWF2OjIQrc5LjqwAABJJJREFUWMPtmNmW2jAMhpWFsIXsgSSEfR/KMoXO4vd/sMrOBCjETsxF29PT/wYOTj5LsizLwG9SY7yzjlF0tHbjxtOQ4TZVyI2UdDuUp8wigxTIiGZSmHbzYkYzdDodJ2xejGu2q2Nevl7Rzo2bcJ21L/xLNdRnmFEC/3HMDzJW+FnOsZgPdZc37taZx1YJxmfmpGsQaJ0yo3zhiht0tj2UaE+tNgS5MKYPtHQold6iE455wzHldKCSOpQUC+z5DhX1nWvTDDnKCSrrRJ8vyPMGjXMMEoppxB+3soM/WyAlC19x4E7f8MclSGqJL32DX3RAh5u2LMhuYpgO944pXZBWV7lzrsZslBeLSA2uWqBj8JTQucVNKiJ3LA95fDXEHQZPCnddeFkypP54FvQDX84XbkuICU/LJGR7/XoEjuZ5cvXnfSjU8WJGF42bcM7HFUmz9NId4hQXqgm+3s1zweRwOrTQdSmnTgu5zvPtW57VKy6HkRiHS1rl2W0QMuVyAgNJM+QogcIhTQkxgAof93icNrhIQoRSgxqH5OFz7OTAp/gcoCTGAS4Jfx7SswVjLeCAntJztwt8EkabnmABIamIU88iLiDhTAF+vOKYmKNsDCEJH3nFD42QgZhTA1dIGhCi4UeEoBIOiEkIirKTzvDEHDHJw6Hgq8zWPRFHTPLqX+W2y9qq5DKg5RwY5JwLKbVz0iUaSZPku7ZFqCwfmGwj5+gXzpU0h5yUmeRbWXIAZIlEk/dl38i2ziCvlh8dFW41XOUthtr5YFHY026ThSjfIxqhqI0PEvI3FEM0tkPyOjJSQ4IyLbcqxrVMggrV0fWMjJGg2+0sVuluUk6Z7NIsNm1bN69NTD9kXtqxQ5jqQc0XeFQL6oTJiW0W4bB/c6QozI4Z9tFMyvItXvsPjHX8tswvAMGM2abgUfawW1B99dUkuRY9630zjWu1eLp5t3qLy4D5qlIrHnfq+rYXsIejnkG4MnqjoX3bfazvWsvFrSe2u98OzHuGOdjuXfvW18V9+9po0ZpyLy9Bn96s49F6Qw+Tx8r+igt310WqOOEZJHXGl9SCzvLFk+N4L0X9awOTadWX4fRXmEINeNAaM2IjA9pguhVeo0Y44FbnuDjxqNjUHuaAXpWj48r3+pyxJq3iFRXhLuHOmnCs5cQh4Q9/4PCwCmeIU36UrGjLL+f4rbJc8TBMWjlIwwCVZG9COG3XXWtFEijRO4ZpDkLNMUDvUCYbi5xjC59wsJjZFQq7QcgOBNoRYkyggtrUObFjbaikHia/xChfE0WwKAk7cSoqEOy5iJ6BVeXhrD4np9FaiULa+eWmenf77cjdeUecXS93iz7Ry1yhtoScJEBj7tbV5K7RCXfZIpoZ1eVi0nHT0ZUArdldkHPLW0uA5ty/bpass5XJyCb3LwxP8jKfcFbBlP2zypzaDyVtasr+7XVYsN5sd1Lnk4PnHSZz9bRjfdziAFL6dEihnE+QVL+9fMQs2314Qvp5ZEXLMG210nAZWaOzDv/1l0tXC/TMuqmkQOqfBM20As3gv0pj9E8sv2Rm/wSWfvVB5J+tIwAAAABJRU5ErkJggg=="

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABjCAMAAADZ/WzlAAAAqFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8j1z1tAAAAN3RSTlMAKNcK7nLiuwUC/fdePueL3Bv5m3tZT9LAopSPVEM4IQ7y6sWvrIAxEKmHdm1hShSdK82yyBdkPeoh4gAAAyxJREFUaN7tmOmSojAURgfZBRHEbVzafR1be53z/m82SDkipumiJqmpWbh/jEk4ZLm5+S5ffoc92XZU3GrbdnFjZNtPhY010IofBYobNahV3Ipbcf9T7ukIHE9quc73RZ2z1RffHXXccY3MamNVXPM81lY/3sf91nnMphpuGzDMbVremgbQVsHt1qF/yvavD/WuPFcPwHZu99CGQJfmrsGa5mqmFqyluQF07qo6EMhyHxKGe1fnBvAgyTUhFvrFYEpymylCfFlTkvsVfKGfD18lucOC8Q4lud9gIPQbwDdJbgMsoZ8FDUmuO4fu/cmGuSvHTR2ipudPdtKtKX3etgbscjU7MLby8ewRWOrZaJfAo4r4OwQs30nLjm+ROZkc192TmLHam/uVQWJ7V9H91gnILOiou4/1dnihhm1drX7QfMDX/hq9U3Er7j/LjQ47mA1HulJuY8HFvDhSxtV33Jh3UMSd9M6018OxMVq/kNiTq4I7rZ1R0c8VOZMHKrhL8DrZXycGHuW5R6iP7gXdfCrNfRGmrYfQluVqMDuJar4my/0GOyE3nSUUSe7XjyTKK4wkuTaMP1KxB0nuW5bAZLbPqePp49IAvLf2pDx3mRexYurgHOb8tHocleUOYC3062WL875IiZ5lpL/zcUluF3of+Z5+iR0WEJqT83KMbKDVKcfVPeiKy7C6LG0vIZnONZxa4D0UcEU1H+Y19rh+3cs44dzO/L0Hll7AFdV8/7brc1KxvBTr96l1NId2EVf8OtHLnHM0A+v9uiCvovY3nHJx3QRag3TmercPzDYXFzNgcy/RQxiXvId8j8SMl34tLYTPWeYXfrQfzbL35sbmaq3h9pMkOlknWJXlJkOLg5TaW09ysa4p9HyARTlu9kCYvyYOMBRHAH0JvSNOOVucnST3OcuiM3uCtaw+s+B4f+7PvifLbULPFT6ahdJ68jS794hGCzoS3MzTaN9iDVio0L8rYDm55qwtsCIVXD2N5St/Ez0fBwEQbNTodXdY58beIvk8QAwelu+qzC8089WDRbPh/jl5S8WtuBW34v4id6JpziePap+81NG0XL7zA/Y55bG0AWdAAAAAAElFTkSuQmCC"

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAAllBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////AJcWoAAAAMXRSTlMA5zceRthO0IyS/QLcXqkr4bujE+5wJQ4K84V6GfjlmGJD1MMzzsvItLBsZjwHv5pW6n7hJgAAAe5JREFUaN7t2Ntu4jAUheENhgBOgUCOBMqh0HM7M+v9X25sJ5JLadQkza5ayb/UcgP6tCIh2RD58XHb42q72JMiFuBtSbQGd3u6AXcLkgC8Pld7AFvSkiCu+gB6znCGM5zhjJ9p+KfDhtnoB4BcZpyGWEG34zRmMF2HfMZcAtB/az5Dz7jK9dtfGQw7Y7ox/xkMO8M3L3dMxrwc8ALVC4NhZ5A5Us5YjHKG6hmAFAyGnUGZ/ibmDEY5wzQBEGVdG3aGLtHec+eGnaHT96Gbzg07Q+dBdejYsDNMfgDg4UtGPnrf9mxGcbOTCRWl+XFUUVxpLPFRU7KF1wAm5cYrVDZuYtgZ9i2rlFRZgM6M6cUDhnkSO7QyTt4H+XTWXTntANWDV9H8S2efKVRe8aSiDc/56jUyV+5dcbvnMWgMVSyNxGUIiaKVYDPosTSeiM8YwHT0GQ0amvNcQpxGDNWaWI00AO59XoOSyTr7pXccZzjDGc5whjO+3ejpM/Lw0+7/2Q8mu9thzfSpeEQz1Mv+djVYoVFjEhHqlZRE2GtGBCHR/BZ1WtjLQaP+CNKJweed/Lfn9sdBzRr/mGqNCdXOGXSWM5zhDGc4w+YMXSou+quMpbgobUvksskxqlUhmrRpZaSyASFDatVTVJuIYqrqPx50RAMEBre5AAAAAElFTkSuQmCC"

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAAgVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9d3yJTAAAAKnRSTlMAuUvUZmljvBEhA/jPCOUX1Y+KX1Lgqj/bx0XowVAmynBWOCrpoZeAMOpXKT4mAAAB4ElEQVRo3u3Y226qQBiG4V8rCgybskcRWrVd7fru/wIXhk6gY0YwnUlWmv89/YKPcDQZupYVpUuzXco3yN7KCz2UAyCYRV4FponXR4l55AC1w2PEPOIXQN16srYGCn8pkUEWhKSvAoRHY54AqqVGARQNsAdwuv9X9jRtD2RLjRK19wSsU4iO9G2AFU1bARta2qdPV4M8lywYssEgYoMNNthgg43/znieGpeyERgSUdnZMNSjmmPwW+mPaqbfw4+AOu+8oe4kj2pmDP1R7Wz4W23Vo9oLkBk2HPWndsCWDTbYYIMNNiwZrkxrPP/MOK8EZGJ3tvEeH/jeh3mjhVpu+lv5ERAcXFkVAH9Dw+9RASKmsVgAB7PG7cXWEdgaNrbATh0cNthggw022GCDDTbWmmvD42jsVFwaxxv87nk3ByKfxvzma2rVIQJa6lsDjTrkd40YQOqPDyQAXDkkyhBTn6sMqRy0Bl2fjVay6EoOQ7p8SGbuXsMA3wvCxwetIZEE09JQMyTjkN4M2m8li/ONM7TJY6KfDOp7mOoXGt0ptG24AoGrXHibzgNG5B04+mS+dIJU6JFsbb79BPkDi5WDEdpECvqqen95Ml+Dvoxs5hUAHLKZX1sn6FMSNiuLjPr+AetO8b8FFiMYAAAAAElFTkSuQmCC"

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAAq1BMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////Nr6iZAAAAOHRSTlMA/YMF5iO5N/b63rDopmVRPzwyKdnF8OLWy76riHpKQxYL8p6WjX8fD7RrX+zTWlYv2y3PknZ0s9pL8hIAAARuSURBVGjetZnXduowEEXHuNtgMJhuCIQOoYQEMv//ZReNLpgE44Kl/URZrGNNOSMJyMrI92ZurxtoLS3o9tyZVxuBSBrr/gc+8uGuGyCE2kTD55Qnb1AQveRgGu2wyGpMV8E77E7PrUxn04rb69h4z8p8NUgG3nhfnYa6ChGqPjz/tPBG75WQ6Su88jUwVYhDNU9dvGLokA91biFHC4/JNRe2kWOVxpAD//O6hD2kU70uxskRsIGCRHMI2Rg2kVDmWTvaQELbQ3aqbSR6mbq/rvFHmo0hD+PQ5k1pQipv78gI6pCXY4eXeWqA9/xpKmPIz3jCW3UHiXiUbcuD19hYFOZ14ipIolWDV/E/SGSXkAsKlHYoMgbaFK6nOalTuj91KMIioMSbT/pCo1XoUIwFraQc3ycG5eJQfGpSTnqxBkIVVYPi+FRd85gvqKQ8EMGGiuvBIFVKVSXV/NYLyAA1ozOOi1SQ1t0hYiuLyJhspQS/0C22ulSPYtk8Z/IumyVXh3t+mO43pKHQ02UhpPH7K+HUGUuBGmPqkre/rbEDgRpQ/dMkdfa+C0I1gMZvZCkue1sVrDGkzd2tqNhPtyBYA2i30gDOnLIhXIMyEgLnk/mkKlwDWGm17wp3BuI1wqh8p+zlQYJGAy9MbkvaggQNynqZqorMXorG6VpZHnvhS9Ew8cIaACrMIVUpGio7BLkAoJFBStEgO/8AWOKFgSSNM14Y8ZhVJWmQZ9X4fG9I0qCa9agZFVWShmqThfTZ9hMkaUCHFRaNwKY0jR4NwyaVriwNlwbsFhH7sjSowQNwyBslaZCna1CmjVUOjWbpCecFPDBjR4G860iitYhfR7582JjIOj4f+eqqi4kM4+sqX38cu7bylI/wSX/QahyQQdTnJe5X4on8KvJd0US+G80PGdD88KM5KIMTzcFonstgRfM82pdIQH3/3+Aen7kSiPZXOj/mymBwrVlyxQ7I4Is5YrRvr4N4jtG+3eRnc/GEd5kO+DlKOFpkhdF5UCz7+2JaKDKyThlXdPhPX4ZnkVe5cOVAfxGAWKJ7hshXcCM+G8bfpi8vQRxj7cGiXPbJFMQxu96WRCzoHs4EUdQVuoeLmSbOUlSkgrgDudpB8noxVOhSXX3wepubvQhoJCn+kzOo/QbFqVlP9wg/dOFf3OQPLd4acYz4hb8OxdCpM7QRxHKkB3D0YhIOD0dyIMv1IoHS0tJaVegh3l5PN4VC2UMCGxKxXy1hzyIJDxKpWsjoL1/p7goy7H221aJj5veoALNG+thGhjLNt5Tlt4IMLVPFjFZIlPMMrZ2GhDGCbJxtJL5oxuf4l14ZQGbMDnI6OxXSUHdb5AQ+5EA9WcgpfycH+DArI8caqJCPhYtXOqVa/K9Vf77FKz865Mdc4Q3LGFQb90JqozowLLxh+K+aT1/BOxSnafQn35O+0fz8/YVbxOIW8wDT+JzrUBBz6iQItKc+CEH3Kho+olU8HUSyNDelitHcOmVne0lLuDEze80/Y1A0tdLob7EAAAAASUVORK5CYII="

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABGdBTUEAALGPC/xhBQAAAedJREFUaAXlmo1tgzAQhVEnYLAMkdmSjhRljCgLVPS9pETGBdv3Vxz1JLehvrv3PTBBqB6maRoxzhg3jAvGYeg0yIZxxbhjkHkc8OMTI40vHBx780AmDLKlcaIBusmjKxOAW4Mn840GeEnWogsTANuCJ/OFBriu8kvDScauJqBfgifb835tSPzze0LMJC4IvMvVLOpCRzNmBnMDgxk3bbdGAjPumu4NC2bCtMIaJ2bCNSIFInsn52jgw672QDkuChoOInoWZT0FPXsVofNJD2GPHjmX6NgCYKkVQdaSNSCamhqHaV4CJMk1QUmLW8BacqS6rvkNgF2+ayxOQsUEpn/Fri9KC/j5AIilh13qoD94gQl3+I9Z/N//fuslJICf7wX3paReQRV4gnKsxf4mQFX65nkAtuSoz56lUAImybUwNddqgDQ1zUCSRAuIpVbCuJnrAeDRYxOwNOEp7NmrxPyaixCM6PkCTj9ECkX2fngIF4BKmEZY4/Ty/nx213JvuAKd/8lN061RTthwbNY2N2iArKWoGdSFNSLFvJhFXKCAkpY0MyHxvf/NCgPcH7EW+79w4LIBrPTOcWUCN3nk0QX8vOwAt2XiTgOnjL4r+IqJMw1wuw13rHDTB/dN9L7dhkueq4YnfvwGmnOgJR53iwMAAAAASUVORK5CYII="

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(110),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(75)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(115),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-89b92c80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(73)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(113),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4754649c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(76)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(116),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-952ee366",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(71)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(111),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(114),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d3f1e6c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "option": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "swiper-wrapper-img b1"
  }, [_c('p', {
    staticClass: "t1 top"
  }, [_vm._v("OCEANBLUECLOUD")]), _vm._v(" "), _c('p', {
    staticClass: "t2"
  }, [_vm._v("Make Connection Easy")]), _vm._v(" "), _c('p', {
    staticClass: "t2"
  }, [_vm._v("Make Business Agile")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "swiper-wrapper-img b2"
  }, [_c('p', {
    staticClass: "t1 top1"
  }, [_vm._v("OCEANBLUECLOUD")]), _vm._v(" "), _c('p', {
    staticClass: "t3 top1"
  }, [_vm._v("High Performance")]), _vm._v(" "), _c('p', {
    staticClass: "t3"
  }, [_vm._v("Strong Security")]), _vm._v(" "), _c('p', {
    staticClass: "t3"
  }, [_vm._v("Flexible Deployment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "swiper-wrapper-img b3"
  }, [_vm._v("OCEANBLUECLOUD")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'language-ch': _vm.language == 'ch' || _vm.language == 'en'
    },
    attrs: {
      "id": "app"
    }
  }, [_c('app-header', {
    attrs: {
      "language": _vm.language
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "overlay"
  }, [_c('span', {
    on: {
      "click": _vm.closeVideo
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('video', {
    attrs: {
      "id": "myvideo",
      "src": _vm.videoUrl,
      "controls": "",
      "webkit-playsinline": "true",
      "playsinline": "true"
    }
  }, [_vm._v("\n        您的浏览器不支持 video 视屏播放。\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('router-view', {
    ref: "currentPage",
    attrs: {
      "language": _vm.language
    },
    on: {
      "isPlay": _vm.playVideoFn
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isWeChat) ? _c('header', [_c('div', {
    staticClass: "header-contain"
  }, [_c('div', {
    staticClass: "header-middle"
  }, [_c('router-link', {
    staticClass: "fl logo",
    attrs: {
      "to": {
        path: '/'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [(_vm.language === 'ch') ? _c('span') : _c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(99)
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showFirstMenu
      }),
      expression: "{ methods: showFirstMenu }"
    }],
    staticClass: "show-menu-img tap-box"
  }, [_c('img', {
    attrs: {
      "src": "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAwCAYAAABNPhkJAAAABGdBTUEAALGPC/xhBQAAATVJREFUaAXtmjESAUEQRQ2pROgIIjGBQCBxApbQERxCuQE5FyARCmxKrSrRphyAdK3/g6mSCWTdv6t+zeyK3htL9exUKqiyLBMkQwrEWpGJbAlZAyYjjBteOKgxgc8AbTuAJeKFwE9M6k6AX1WAZk5giZlxhfuYHJAa7xiuAmyDQEBAdzHMkRZiDZygN2QZQjhhVMmADMiADMiADMiADMiADMjAbwOxW2KH1EMsd0tHdEsF++EGQPdIB7FcKeCGBF5hMrNM+sW2JvAdN5pfNy1PH9zTclUE3jki3vn70eLq4jl287fk6NssVBmQARmQARmQARmQARmQgX8MxE08N0ce2A/7OtQCYB70sL5jGZ+ClCvs7mBaHvEdjDk38RYOQCPioorXD1tcTZAr8o6fGBrJRLYpWT+7UEMEgMF5qQAAAABJRU5ErkJggg=="
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.hideFirstMenu
      }),
      expression: "{ methods: hideFirstMenu }"
    }],
    staticClass: "hide-menu-img tap-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(100)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-contain"
  }, [_c('ul', {
    staticClass: "first-menu"
  }, [_c('li', {
    staticClass: "first-item item clear"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.toggleSecondMenu
      }),
      expression: "{ methods: toggleSecondMenu }"
    }],
    staticClass: "text-contain"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v(_vm._s(_vm.$t("language.headerSolutions")))]), _vm._v(" "), _c('img', {
    staticClass: "fr trangle-img",
    attrs: {
      "src": __webpack_require__(3)
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "second-menu"
  }, [_c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/solutions/enterprise'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.enterprise")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/solutions/virtualNetwork'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.vn")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "space"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "first-item item clear"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.toggleSecondMenu
      }),
      expression: "{ methods: toggleSecondMenu }"
    }],
    staticClass: "text-contain"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v(_vm._s(_vm.$t("m.product")))]), _vm._v(" "), _c('img', {
    staticClass: "fr trangle-img",
    attrs: {
      "src": __webpack_require__(3)
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "second-menu"
  }, [_c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/product/connection'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.headerServicesConnection")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/product/delivery'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.headerServicesDelivery")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/product/global'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.headerServicesGlobal")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/product/mobility'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.mobility")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/services/device/R100-X6'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.device")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "space"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "first-item item clear"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.toggleSecondMenu
      }),
      expression: "{ methods: toggleSecondMenu }"
    }],
    staticClass: "text-contain"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v(_vm._s(_vm.$t("m.technology")))]), _vm._v(" "), _c('img', {
    staticClass: "fr trangle-img",
    attrs: {
      "src": __webpack_require__(3)
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "second-menu second-newMenu"
  }, [_c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/services/sdwan'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.headerServicesSd")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/technology/download'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.download")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/services/download'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.downloadHeader")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/free-trial'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.freeTitle")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    staticClass: "fl",
    attrs: {
      "to": {
        path: '/partner-apply'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.partner_title")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "space"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "first-item item clear"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.toggleSecondMenu
      }),
      expression: "{ methods: toggleSecondMenu }"
    }],
    staticClass: "text-contain"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v(_vm._s(_vm.$t("language.headerAbout")))]), _vm._v(" "), _c('img', {
    staticClass: "fr trangle-img",
    attrs: {
      "src": __webpack_require__(3)
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "second-menu company-menu"
  }, [_c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/about'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.aboutUs")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/expert'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.manage")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/award'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.awards")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "text-contain"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/news'
      },
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.routerClickFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("m.news")))])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "first-item item clear"
  }, [_c('div', {
    staticClass: "chang-language text-contain"
  }, [_c('img', {
    staticClass: "language-img",
    attrs: {
      "src": "data:image/gif;base64,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"
    }
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.changeLanguage()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("language.headerLanguage")))])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "show-avatar-img tap-box",
    attrs: {
      "href": "https://cc.oceanbluecloud.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(98)
    }
  })])
}]}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-message",
    class: _vm.type,
    on: {
      "mouseenter": _vm.clearTimer,
      "mouseleave": _vm.startTimer
    }
  }, [_c('span', {
    staticClass: "message-icon",
    class: ("icon-" + _vm.type)
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "footer-bg"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "data:image/gif;base64,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"
    }
  })])])
}]}

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-page"
  }, [_c('div', {
    ref: "banner",
    staticClass: "banner"
  }, [_c('app-swiper', {
    attrs: {
      "language": _vm.language
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-section"
  }, [_c('div', {
    staticClass: "tab-main"
  }, [_c('ul', {
    staticClass: "outer"
  }, [_c('li', {
    staticClass: "outer-item show-detail"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showTabDetail
      }),
      expression: "{ methods: showTabDetail }"
    }],
    staticClass: "top-travel clear"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    staticClass: "icon icon1",
    attrs: {
      "src": __webpack_require__(81)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainWhatWan")))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', [_c('p', [_vm._v(_vm._s(_vm.$t("language.mainWhatWanDefined")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainWhatWanGlobal")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainWhatWanConnection")))])])])]), _vm._v(" "), _c('li', {
    staticClass: "outer-item"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showTabDetail
      }),
      expression: "{ methods: showTabDetail }"
    }],
    staticClass: "top-travel clear"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    staticClass: "icon icon2",
    attrs: {
      "src": __webpack_require__(82)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainWhyWan")))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    attrs: {
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.jumpRouter()
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("language.mainWhyWanHeight")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainWhyWanStrong")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainWhyWanFlexible")))])])])]), _vm._v(" "), _c('li', {
    staticClass: "p4 outer-item"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showTabDetail
      }),
      expression: "{ methods: showTabDetail }"
    }],
    staticClass: "top-travel clear"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    staticClass: "icon icon1",
    attrs: {
      "src": __webpack_require__(83)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainCloud")))])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', [_c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudSaas")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudApp")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudSoho")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudRemote")))])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.language == 'ch'),
      expression: "language == 'ch'"
    }],
    staticClass: "p4 outer-item"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showTabDetail
      }),
      expression: "{ methods: showTabDetail }"
    }],
    staticClass: "top-travel clear"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    staticClass: "icon icon1",
    attrs: {
      "src": __webpack_require__(16)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainCloud1")))])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', [_c('p', [_vm._v(_vm._s(_vm.$t("language.mainGlobal")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainData")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainSafeData")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainSimple")))])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.language == 'en'),
      expression: "language == 'en'"
    }],
    staticClass: "p4 outer-item"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showTabDetail
      }),
      expression: "{ methods: showTabDetail }"
    }],
    staticClass: "top-travel clear"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    staticClass: "icon icon1",
    attrs: {
      "src": __webpack_require__(16)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainCloudConnection")))])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', [_c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudBranch")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudData")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudSecured")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudEasy")))])]), _vm._v(">\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "feature-section"
  }, [_c('div', {
    staticClass: "gradient"
  }, [_c('div', {
    staticClass: "top-text-contain"
  }, [_c('h1', {
    staticClass: "top-title"
  }, [_vm._v(_vm._s(_vm.$t("language.mainFeatures")))]), _vm._v(" "), _c('div', {
    staticClass: "middle-title"
  }, [_vm._v(_vm._s(_vm.$t("language.mainFeaturesWe")))]), _vm._v(" "), _c('p', {
    staticClass: "bottom-text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainFeaturesBuild")))])]), _vm._v(" "), _c('div', {
    staticClass: "feature-classify"
  }, [_c('ul', {
    staticClass: "all-item clear"
  }, [_c('li', {
    staticClass: "item fl"
  }, [_vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainPERFORMANCE")))])]), _vm._v(" "), _c('li', {
    staticClass: "item fr"
  }, [_vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainSECURITY")))])])]), _vm._v(" "), _c('ul', {
    staticClass: "all-item clear"
  }, [_c('li', {
    staticClass: "item fl"
  }, [_vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainRELIABILITY")))])]), _vm._v(" "), _c('li', {
    staticClass: "item fr"
  }, [_vm._m(8), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainSMART")))])])]), _vm._v(" "), _c('ul', {
    staticClass: "all-item clear"
  }, [_c('li', {
    staticClass: "item fl"
  }, [_vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainEASY")))])]), _vm._v(" "), _c('li', {
    staticClass: "item fr"
  }, [_vm._m(10), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainREAL")))])])]), _vm._v(" "), _c('ul', {
    staticClass: "all-item clear"
  }, [_c('li', {
    staticClass: "item fl"
  }, [_vm._m(11), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainANALYTICS")))])]), _vm._v(" "), _c('li', {
    staticClass: "item fr"
  }, [_vm._m(12), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainFlexible")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "classify-detail"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("language.mainShowMore")))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showFeaturesDetail
      }),
      expression: "{ methods: showFeaturesDetail }"
    }],
    staticClass: "expand-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(89)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "feature-detail"
  }, [_c('div', {
    staticClass: "top-contain"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainFeatures")))])]), _vm._v(" "), _c('div', {
    staticClass: "classify-contain"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.hideFeaturesDetail
      }),
      expression: "{ methods: hideFeaturesDetail }"
    }],
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(88)
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "classify-list"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainPERFORMANCE")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainPERFORMANCEDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainSECURITY")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainRELIABILITYDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainRELIABILITY")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainSECURITYDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainSMART")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainSMARTDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainEASY")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainEASYDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainREAL")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainREALDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainANALYTICS")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainANALYTICSDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainFlexible")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainFlexibleDetail")))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "application-section"
  }, [_c('div', {
    staticClass: "text-contain"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("language.mainGlobalImprove")))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainGlobalSaas")))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/product/global'
      },
      "push": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("language.mainClickShowMore")))])])], 1)]), _vm._v(" "), _vm._m(13), _vm._v(" "), (_vm.language == 'en') ? _c('div', {
    staticClass: "text-contain"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("language.mainGlobalEnterprise")))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainGlobalWith")))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/product/global'
      },
      "push": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("language.mainClickShowMore")))])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.language == 'en') ? _c('div', {
    staticClass: "img-contain"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(85)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "world-section"
  }, [_c('div', {
    staticClass: "title-contain"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("language.mainWorldwide")))]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("language.mainSmart")))])]), _vm._v(" "), _c('img', {
    staticClass: "world-img",
    attrs: {
      "src": __webpack_require__(86)
    }
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('img', {
    staticClass: "icons",
    attrs: {
      "src": __webpack_require__(87)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle-contain fr"
  }, [_c('img', {
    staticClass: "trangle",
    attrs: {
      "src": __webpack_require__(2)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle-contain fr"
  }, [_c('img', {
    staticClass: "trangle",
    attrs: {
      "src": __webpack_require__(2)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle-contain fr"
  }, [_c('img', {
    staticClass: "trangle",
    attrs: {
      "src": __webpack_require__(2)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle-contain fr"
  }, [_c('img', {
    staticClass: "trangle",
    attrs: {
      "src": __webpack_require__(2)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle-contain fr"
  }, [_c('img', {
    staticClass: "trangle",
    attrs: {
      "src": __webpack_require__(2)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(90),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticClass: "img2",
    attrs: {
      "src": __webpack_require__(91),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(92),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticClass: "img4",
    attrs: {
      "src": __webpack_require__(93),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticClass: "img5",
    attrs: {
      "src": __webpack_require__(94),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(95),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(96),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(97),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-contain"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(84)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "world-text"
  }, [_c('p', [_vm._v("HQ/DC")]), _vm._v(" "), _c('p', [_vm._v("Branch Office")])])
}]}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[41]);


// WEBPACK FOOTER //
// static/js/app.a49ea84a463a79965e35.1786930865334.js